<template>
  <div class="merchant">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-radio v-model="radio" label="条件查询" class="x-m-l-20 x-m-r-5" @change="fHeadRadioChange">条件查询</el-radio>
        <el-radio v-model="radio" label="区域查询" class="x-m-l-5 x-m-r-20" @change="fHeadRadioChange">区域查询</el-radio>
        <!-- <el-cascader
          size="medium"
          :options="sortOptions"
          v-model="searchSortVal"
          @change="fHeadSortChange"
          style="width: 160px"
          class="x-m-r-2 x-m-l-5"
        ></el-cascader> -->
        <el-cascader v-if="radio == '区域查询'" size="medium" :options="[
          { label: '商户', value: '商户' },
          { label: '代理商', value: '代理商' },
        ]" v-model="searchTypeVal" @change="fHeadTypeChange" style="width: 100px" class="x-m-r-2"></el-cascader>
        <el-cascader clearable v-if="radio == '区域查询'" size="medium" separator="-" placeholder="区域查询（可选）"
          :options="shMallAddressOptions" :props="{ checkStrictly: true }" @change="fHeadAddressChange"
          v-model="searchAddressVal" class="x-m-r-15"></el-cascader>
        <el-button size="medium" type="primary" @click="nowPage = 1; init()" v-if="radio == '区域查询'" class="x-m-r-15">查询
        </el-button>
        <el-input v-if="radio == '条件查询'" placeholder="手机号 用户名 门店名 代理商" v-model="merInputVal" size="medium"
          style="width: 300px" class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage = 1; init()">搜索</el-button>
          <!-- <template slot="append">搜索</template> -->
        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>
        <!-- <el-button size="medium" type="primary">区域查找</el-button> -->
        <!-- <el-button size="medium" type="danger">清空</el-button> -->
      </div>
      <div class="x-flex">
        <!-- <div class="x-m-l-10 buy-software"> -->
        <el-button v-if="
          bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
        " type="" size="medium" @click="fShowMchTotal">商户汇总</el-button>
        <el-button v-if="
          bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
        " size="medium" @click="fTest">链路测试</el-button>
        <el-button type="primary" size="medium" @click="buySoftware = !buySoftware">软件购买</el-button>
        <!-- </div> -->
        <el-button type="danger" size="medium" @click="fRegMerchant">注册商户</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center" ref="xTable1">
          <!-- @header-cell-click="fTablePhoneClick" -->
          <vxe-column field="RC" title="序号" width="50" fixed="left">
          </vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="item in tableJson"
            :key="item.id">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                    'el-icon-caret-top',
                    sortType == item.sortType && sortAscDesc == 'asc'
                      ? 'active'
                      : '',
                  ]"></i>
                  <i :class="[
                    'el-icon-caret-bottom',
                    sortType == item.sortType && sortAscDesc == 'desc'
                      ? 'active'
                      : '',
                  ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column v-if="
            bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
          " field="user_ip" title="服务器地址" width="130">
            <template #header>
              <div class="x-flex x-row-between w100p" @click="fHeadSort('user_ip', 'asc')">
                <span>服务器地址</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                    'el-icon-caret-top',
                    sortType == 'user_ip' && sortAscDesc == 'asc'
                      ? 'active'
                      : '',
                  ]"></i>
                  <i :class="[
                    'el-icon-caret-bottom',
                    sortType == 'user_ip' && sortAscDesc == 'desc'
                      ? 'active'
                      : '',
                  ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column v-if="
            bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
          " field="db_name" title="数据库名" width="220">
            <template #header>
              <div class="x-flex x-row-between w100p" @click="fHeadSort('db_name', 'asc')">
                <span>数据库名</span>
                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                    'el-icon-caret-top',
                    sortType == 'db_name' && sortAscDesc == 'asc'
                      ? 'active'
                      : '',
                  ]"></i>
                  <i :class="[
                    'el-icon-caret-bottom',
                    sortType == 'db_name' && sortAscDesc == 'desc'
                      ? 'active'
                      : '',
                  ]"></i>
                </span>
              </div>
            </template>
          </vxe-column>
          <vxe-column fixed="right" title="操作" width="160" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="fModify(scope.row)" class="x-m-l-4" style="color: #2c8ff2">
                修改
              </el-button>
              <el-button type="text" size="mini" class="x-m-l-4" @click="fDisposeMall(scope.row)"
                style="color: #f56c6c">
                配置门店
              </el-button>
              <el-button type="text" size="mini" @click="fShowMorePop(scope.row)" style=""
                v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
                更多
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>

        <div class="x-flex"
          style="position: absolute; bottom: 15px; left: 20px; z-index: 999 ;line-height: 32px;height: 32px;">
          <div class="x-flex x-p-r-10">
            <el-radio v-model="timeRadio" label="全部" class="x-m-l-20 x-m-r-5">全部</el-radio>
            <el-radio v-model="timeRadio" label="REG" class="x-m-l-20 x-m-r-5">注册时间</el-radio>
            <el-radio v-model="timeRadio" label="LOGIN" class="x-m-l-5 x-m-r-20">最后登录</el-radio>

            <div v-if='timeRadio == "REG"'>
              <!-- <el-date-picker v-if='timeRadio == "REG"' style="width: 400px;" v-model="time" size="small"
                type="datetimerange" @change="nowPage=1;init()" format='yyyy-MM-dd HH:mm:ss'
                value-format='yyyy-MM-dd HH:mm:ss' :clearable="false" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker> -->
              <el-date-picker style="width: 140px;" size="small" :clearable="false" @change="nowPage = 1; init()"
                v-model="startTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间">
              </el-date-picker>
              至
              <el-date-picker style="width: 140px;" size="small" :clearable="false" @change="nowPage = 1; init()"
                v-model="overTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间">
              </el-date-picker>

            </div>

            <el-date-picker v-if='timeRadio == "LOGIN"' size="small" :clearable="false" @change="init"
              v-model="lastTime" type="date" placeholder="选择日期时间">
            </el-date-picker>

          </div>
          <div>
            共 {{ TP }} 页 {{ TR }} 条 <span class="u-m-l-20" @click="fExportDataEvent">导出</span>
          </div>
        </div>
        <el-pagination background layout="sizes,prev, pager, next" :total="Number(TR)" :page-size='pageSize'
          :page-sizes="[50, 100, 200, 300, 400, 500, 1000]" @current-change="fCurrentChange" :current-page="nowPage"
          @size-change="fSizeChange" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <!-- 软件购买 -->
    <!-- <el-dialog :visible.sync="buySoftware" width="500px" :show-close="false">
      <div class="dialog-title">软件购买</div>
      <div class="centent">
        <div
          :class="['buy', buyType == 'buy1' ? 'buy-active' : '']"
          @click="fBuyChoose('buy1')"
        >
          <div class="buy-title">单店购买</div>
          <div style="font-size: 14px">按门店计费，商户终身版</div>
          <div class="price">¥ 299</div>
          <el-button @click="fGoBuy('299')">立即购买</el-button>
        </div>
        <div
          :class="['buy', buyType == 'buy2' ? 'buy-active' : '']"
          @click="fBuyChoose('buy2')"
        >
          <div class="buy-title">包年</div>
          <div style="font-size: 14px">无限制注册商户</div>
          <div class="price">¥ 3980</div>
          <el-button @click="fGoBuy('3980')">立即购买</el-button>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog :visible.sync="buySoftware" width="350px" :close-on-click-modal="false">
      <div class="x-m-t-30 x-flex" style="flex-direction: column">
        <div class="x-font-16 x-m-t-10">商务热线</div>
        <div class="x-m-t-20 x-m-b-30 x-font-21 c-primary">400-862-5828</div>
        <div class="x-m-b-30">官方网址：https://www.sanmipos.com</div>
      </div>
    </el-dialog>
    <!-- 软件购买付款界面 -->
    <el-dialog :visible.sync="goBuyDialog" width="300px">
      <div class="x-flex" style="flex-direction: column">
        <div style="text-align: center" class="x-m-t-20 x-m-b-10">待支付</div>
        <div class="x-font-24 x-m-b-18" style="color: #f76062">
          ¥ {{ buySoftwareMoney }}
        </div>
        <div style="width: 150px; height: 150px; background-color: #808080"></div>
        <div class="x-m-t-15 x-m-b-20">支付宝扫一扫完成支付！</div>
      </div>
    </el-dialog>
    <!-- 支付成功 -->
    <el-dialog :visible.sync="buySuccess" width="270px">
      <div class="x-flex x-row-center x-m-t-40">
        <img src="../../src/assets/img/sucess.png" alt="支付成功" style="width: 150px" />
      </div>
      <div class="x-flex x-row-center x-font-20 x-m-b-50">支付成功</div>
    </el-dialog>
    <!-- 支付失败 -->
    <el-dialog :visible.sync="buyFail" width="270px">
      <div class="x-flex x-row-center x-m-t-40">
        <img src="../../src/assets/img/fail.png" alt="支付失败" style="width: 150px" />
      </div>
      <div class="x-flex x-row-center x-font-20 x-m-b-30">支付失败</div>
      <div class="x-w100 x-h40 x-bd x-bd-ra-5 x-flex x-row-center"
        style="margin: 0 auto 30px; border-color: #ff6700; color: #ff6700">
        重新支付
      </div>
      <!-- <el-button>重新支付</el-button> -->
    </el-dialog>
    <!-- 注册/修改 商户 -->
    <el-dialog :visible.sync="addMerchant" width="900px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="5vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600" v-if="merchantAddOrEdit == 'ADD'">
          增加商户
        </div>
        <div class="x-font-15 f600" v-if="merchantAddOrEdit == 'EDIT'">
          修改商户
        </div>
        <div class="x-flex">
          <!-- <el-button
            size="small"
            type="primary"
            v-if="merchantAddOrEdit == 'ADD'"
            >生成商户自助注册二维码</el-button
          > -->
          <div class="x-flex x-p-r-10 partnerPhone"
            v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
            <div class="x-w80">
              伙伴手机号
            </div>
            <el-input style="width: 130px;" size="small" v-model="shInfo.partnerPhone">
              <!-- <el-button slot="append" @click="fChgUserPhone">变更</el-button> -->
              <div slot="append" style="cursor: pointer;" @click="fChgUserPhone">变更</div>
            </el-input>
          </div>
          <div class="x-flex x-p-r-10" v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
            <div class="x-w80">
              服务器地址
            </div>
            <el-input style="width: 120px;" size="small" v-model="shInfo.mchSrvIp"></el-input>
          </div>
          <el-button v-if="merchantAddOrEdit == 'ADD'" type="primary" size="small" @click="fSelfReg">生成商户自助注册二维码
          </el-button>
          <el-button v-if="
            bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098' && merchantAddOrEdit == 'EDIT'
          " type="primary" size="small" @click="fDelMch">删除</el-button>
          <!-- <el-button type="primary" size="small" @click="fExecSqlFile">升级</el-button> -->
          <el-button v-if="merchantAddOrEdit == 'ADD'" type="danger" size="small" @click="fAddMerchant">保存</el-button>
          <el-button v-if="merchantAddOrEdit == 'EDIT'" type="danger" size="small" @click="fSaveMerchant">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <!-- 第一行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">软件版本</div>
          <el-cascader size="small" class="x-flex-1" :options="shEditionOptions" v-model="shInfo.shEdition"
            :value="shInfo.shEdition" @change="shEditionChange"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">手机号码</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shPhone" maxlength="11" type="number"
            :disabled="merchantAddOrEdit == 'EDIT'"></el-input>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">联系人名</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shLxName"></el-input>
        </el-col>
      </el-row>
      <!-- 第二行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">用户类型</div>
          <el-cascader size="small" class="x-flex-1" :options="shUserTypeOptions" v-model="shInfo.shUserType"
            @change="shUserTypeChange"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="16">
          <div class="x-w100 x-text-r x-p-r-15 must">门店名称</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shMallName"></el-input>
        </el-col>
      </el-row>
      <!-- 第三行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">所属行业</div>
          <el-cascader size="small" class="x-flex-1" :options="shIndustryOptions" v-model="shInfo.shIndustry"
            @change="shIndustryChange"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="16">
          <div class="x-w100 x-text-r x-p-r-15 must">主要经营</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shMainMarketing"></el-input>
        </el-col>
      </el-row>
      <!-- 第四行 -->
      <!-- <el-row class="x-m-t-15"> -->


      <!-- <el-col :span="7" :offset="1">
          <el-input
            size="small"
            class="address x-flex-1"
            v-model="shInfo.shMallAddress"
            disabled
          ></el-input>
        </el-col> -->
      <!-- </el-row> -->

      <!-- 第四行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">门店地址</div>
          <el-cascader size="small" separator="-" class="x-flex-1" :options="shMallAddressOptions"
            @change="shMallAddressChange" v-model="addr"></el-cascader>
        </el-col>
        <el-col class="x-flex" :span="16">
          <div class="x-w100 x-text-r x-p-r-15 must">详细地址</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shMallDetailAddress"></el-input>
        </el-col>
      </el-row>
      <!-- 第五行 -->
      <el-row class="x-m-t-15" v-if="showKyjmd || showZywz">
        <el-col class="x-flex" :span="showKyjmd ? 18 : 24" v-if="showZywz">
          <div class="x-w100 x-text-r x-p-r-15 must">主页网址</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shHomeUrl"></el-input>
        </el-col>
        <el-col class="x-flex" :span="showZywz ? 6 : 24" v-if="showKyjmd">
          <div class="x-w100 x-text-r x-p-r-15 must">可用加盟店</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.jm_mall_can_use_num"></el-input>
        </el-col>
      </el-row>

      <!-- 第六行 -->


      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="showXxtztx ? 18 : 24">
          <div class="x-w100 x-text-r x-p-r-15">备注信息</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shRemarks"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center" style="height: 32px" :span="6" v-if="showXxtztx">
          <el-checkbox v-model="shInfo.wsYn" :disabled="merchantAddOrEdit == 'EDIT' ? false : true"
            class="x-m-l-15">消息通知提醒
          </el-checkbox>
        </el-col>
      </el-row>
      <!-- <el-row class="x-m-t-30" v-eles>
        <el-col class="x-flex" :span="24">
          <div class="x-w100 x-text-r x-p-r-15">备注信息</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shRemarks"></el-input>
        </el-col>
      </el-row> -->
      <!-- 第七行 -->
      <el-row class="x-m-t-15" v-if="showFpgg">
        <el-col class="x-flex" :span="18">
          <div class="x-w100 x-text-r x-p-r-15">广告网址</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shAdUrl"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center" style="height: 32px" :span="6">
          <el-checkbox v-model="shInfo.shAdChoose" class="x-m-l-15">副屏广告统一管理</el-checkbox>
        </el-col>
      </el-row>
      <!-- 第八行 -->
      <el-row class="x-m-t-15" v-if="showZdmk">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">自定模块</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shCustomModelName" placeholder="模块名称"></el-input>
        </el-col>
        <el-col :span="9" :offset="1">
          <el-input size="small" v-model="shInfo.shCustomModelUrl" class="x-flex-1" placeholder="模块网址"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center" style="height: 32px" :span="6">
          <el-checkbox v-model="shInfo.shCustomModelChoose" class="x-m-l-15">自定模块打开独立浏览</el-checkbox>
        </el-col>
      </el-row>
      <!-- 第九行 -->
      <el-row class="x-m-t-15">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">全部费用</div>
          <el-input size="small" class="x-flex-5" placeholder="0.00" v-model="shInfo.shAllCost"
            :disabled="merchantAddOrEdit == 'EDIT'"></el-input>
        </el-col>
        <el-col class="x-flex x-col-center x-font-12 x-p-l-20" style="height: 32px" :span="8">
          *门店年费合计，具体年费请到门店信息设置
        </el-col>
        <el-col class="x-flex x-col-center x-font-12 " style="height: 32px" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">支付笔数</div>
          <el-input size="small" class="x-flex-5" placeholder="0.00" v-model="shInfo.mustPayCount"></el-input>
        </el-col>
      </el-row>
      <!-- 第十行 -->
      <el-row class="x-m-t-15 ">
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15">可用电脑</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.shCanUseComputed"></el-input>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">商城到期</div>
          <el-date-picker size="small" class="x-flex-1" v-model="shInfo.shShopMallExpice" type="date" placeholder="选择日期"
            :clearable="false" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
        <el-col class="x-flex" :span="8">
          <div class="x-w100 x-text-r x-p-r-15 must">订货到期</div>
          <el-date-picker size="small" class="x-flex-1" v-model="shInfo.shOrderGoodsExpice" type="date"
            :clearable="false" placeholder="选择日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15 x-m-b-30">
        <el-col class="x-flex" :span="12">
          <div class="x-w100 x-text-r x-p-r-15">ORG_AK</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.org_ak">
            <el-button slot="append" @click="fCreatedAkSk('org_ak')">生成</el-button>
          </el-input>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w100 x-text-r x-p-r-15 ">ORG_SK</div>
          <el-input size="small" class="x-flex-1" v-model="shInfo.org_sk">
            <el-button slot="append" @click="fCreatedAkSk('org_sk')">生成</el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- <el-row class="x-m-t-15 x-m-b-30">
        <el-col class="x-flex" :span="24">
          <div class="x-w100 x-text-r x-p-r-15">自动安装</div>
          <el-input size="small" class="x-flex-1" v-model="autoJson">
            <el-button slot="append" @click="fAutoAz('USER_LIST')">保存</el-button>
          </el-input>
        </el-col>
      </el-row> -->
    </el-dialog>
    <!-- 配置门店 -->
    <el-dialog :visible.sync="mallDispose" width="900px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="10vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">门店信息</div>
        <div class="x-flex">
          <!-- <el-button size="mini" type="primary">新增</el-button> -->
          <el-button v-if="showQcSj" type="primary" size="small"
            @click="cancelAllDataDialog = true; clearYzm = ''">清除所有数据</el-button>
          <el-button type="primary" size="small" @click="fResetMall">重置1001密码</el-button>
          <el-button type="danger" size="small" @click="fModifyOrAddMall({}, 'add')">增加连锁门店</el-button>
          <el-button type="info" size="small" @click="fColseMall">退出</el-button>
        </div>
      </div>
      <el-table :data="mallData" style="width: 100%; margin-left: 10px; height: 200px; overflow-y: auto">
        <el-table-column prop="mall_id" label="门店编码" width="90">
        </el-table-column>
        <el-table-column prop="mall_name" label="门店名称"> </el-table-column>
        <el-table-column prop="stop_time" label="到期时间"> </el-table-column>
        <el-table-column prop="fy_money" label="费用" width="80">
        </el-table-column>
        <el-table-column prop="zb_xf_yn" label="总部续费" width="90">
        </el-table-column>
        <el-table-column prop="state" label="状态" width="50">
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="fModifyOrAddMall(scope.row, 'modify')" class="x-m-l-4">
              修改
            </el-button>
            <el-button type="text" size="mini" @click="fPaymentDispose(scope.row)" style="color: #f56c6c">
              支付
            </el-button>
            <el-dropdown v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
              <div class="x-p-l-4">
                <el-button type="text" size="mini" style="color: #f56c6c">
                  更多
                </el-button>
              </div>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="fGetDzjqList(scope.row)">电子价签</el-dropdown-item> -->
                <el-dropdown-item @click.native="fGetYdyjList(scope.row)">云打印机</el-dropdown-item>
                <el-dropdown-item @click.native="fGetJkList(scope.row)">摄像头</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>
      <div v-if="showKhdBbTs">
        <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">客户端版本推送</div>
        </div>
        <el-row>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w80 x-text-c">安卓版本</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.androidVer">
              <el-button slot="append" @click="fSubSrvRegOper('ANDROID_VER')">推送</el-button>
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w80  x-text-c">win版本</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.winVer">
              <el-button slot="append" @click="fSubSrvRegOper('WIN_VER')">推送</el-button>
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w80  x-text-c">强制升级</div>
            <el-select size="small" class="x-flex-1" v-model="mallInfo.forceUpdateYn" placeholder="请选择">
              <el-option v-for="item in forceUpdateOtion" :key="item.val" :label="item.name" :value="item.val">
              </el-option>
            </el-select>
            <div class="x-p-l-10">
              <el-button size="small" @click="fSubSrvRegOper('FORCE_UPDATE')">推送</el-button>
            </div>
          </el-col>
        </el-row>
        <div class="dialog-title x-flex  x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">调试日志 </div>
          <div class="x-p-l-14">{{ downLoadUrl }}</div>
        </div>
        <el-row>
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w80  x-text-c">开启调试</div>
            <el-select style="width: 150px;margin-right: 10px;" size="small" v-model="logSet.logVer" placeholder="请选择">
              <el-option v-for="item in logOption" :key="item.val" :label="item.val" :value="item.val">
              </el-option>
            </el-select>
            <el-input size="small" class="x-flex-1" type="text" v-model="logSet.logMallId"
              placeholder="例:00010001,00010002">
              <el-button slot="append" @click="fMchRegEx({ oper: 'SET_DEBUG' })">保存设置</el-button>
            </el-input>
          </el-col>


        </el-row>
        <el-row style="border-top: 1px solid #e6e6e6;" class="x-m-t-12">
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80  x-text-c">日志日期</div>
            <el-date-picker class="x-flex-1" v-model="logGet.logDate" type="date" size="small" placeholder="选择日期"
              value-format="yyyyMMdd" :clearable="false">
            </el-date-picker>
            <!-- <div class="x-p-l-10">
              <el-button size="small" @click="fMchRegEx({oper: 'DOWN_LOAD'})">下载</el-button>
            </div> -->
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80 x-text-c">门店编码</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="logGet.logMallId"
              placeholder="门店编码 例:00010001">
              <el-button slot="append" @click="fMchRegEx({ oper: 'PUSH' })">获取日志</el-button>
            </el-input>
          </el-col>

        </el-row>
      </div>
      <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
        <div class="x-font-15 f600">客户化参数</div>
      </div>
      <el-row>
        <el-col class="x-flex x-m-t-15" :span="12">
          <div class="x-w80  x-text-c">客户名称</div>
          <el-input size="small" class="x-flex-1" type="text" v-model="custom.custom_name">
          </el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15" :span="12">
          <div class="x-w80  x-text-c">请求地址</div>
          <el-input size="small" class="x-flex-1" type="text" v-model="custom.custom_url">
          </el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15" :span="12">
          <div class="x-w80  x-text-c">拓展信息</div>
          <el-input size="small" class="x-flex-1" type="text" v-model="custom.custom_ex">
          </el-input>
        </el-col>
        <el-col class="x-flex x-row-between x-m-t-15" :span="12">
          <!-- <div class="x-w80 "></div> -->
          <div style="line-height: 32px;" class="x-p-l-20 x-p-r-20">
            <el-checkbox v-model="custom.custom_yn" true-label='Y' false-label='N'>是否启用</el-checkbox>
          </div>
          <el-button size="small" @click="fMchRegEx({ oper: 'SET_CUSTOM' })">保存</el-button>
        </el-col>
      </el-row>
      <!-- 内层对话框 -->
      <el-dialog width="800px" title="" :visible.sync="innerModifyMall" append-to-body class="add-dialog"
        :show-close="false" :close-on-click-modal="false">
        <div class="dialog-title x-flex x-row-betwee x-p-b-20">
          <div class="x-font-15 f600">{{ innerModifyMallTitle }}</div>
        </div>

        <el-row class="x-p-t-20 x-bd-top">
          <!-- <el-col class="x-flex" :span="24">
            <div class="x-w80 x-p-r-15">门店编码</div>
            <el-input
              size="small"
              class="x-flex-1"
              v-model="mallInfo.mallId"
            ></el-input>
          </el-col> -->
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80 x-p-r-15">门店名称</div>
            <el-input size="small" class="x-flex-1" v-model="mallInfo.mallName"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="7" :offset="1">
            <div class="x-w80 x-p-r-15">同步门店</div>
            <el-input size="small" class="x-flex-1" v-model="mallInfo.sync_mall_id"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15 " :span="4">
            <div class=" x-p-l-15 x-lh-32">所有商品信息</div>
          </el-col>
          <!-- <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w80 x-p-r-15">收费方案</div>
            <el-radio-group v-model="mallInfo.sfFaRadio">
              <el-radio label="按存储收费">按存储收费</el-radio>
              <el-radio label="按功能收费">按功能收费</el-radio>
            </el-radio-group>
          </el-col> -->
          <el-col class="x-flex x-m-t-15" :span="24" v-if="mallInfo.sfFaRadio == '按功能收费'">
            <vxe-table border resizable highlight-hover-row height="200px" :data="mallXfData" align="center"
              ref="xTable1" style="width: 100%;">
              <vxe-column field="size_name" min-width='90px' title="功能模板"></vxe-column>
              <vxe-column field="num" min-width='120px' title="包年续费/元" :edit-render="{ autofocus: '.el-input__inner' }">
                <template slot-scope="scope">
                  <div class="f600 c-cz">{{ scope.row.num }}</div>
                </template>
                <template #edit="{ row, rowIndex, column }">
                  <div class='numInput'>
                    <el-input class='delInput' v-model="row.num" type="number" @change='fGetYfMoney'>
                    </el-input>
                  </div>
                </template>
              </vxe-column>
              <vxe-column field="pro_create_time" title="包年到期时间" min-width='160px'
                :edit-render="{ autofocus: '.el-input__inner' }">
                <template #edit="{ row, rowIndex, column }">
                  <el-date-picker style='width:100%' v-model="row.pro_create_time" type="date" format='yyyy-MM-dd'
                    value-format='yyyy-MM-dd' placeholder="选择包年到期时间" :clearable='true'>
                  </el-date-picker>
                </template>
              </vxe-column>
              <vxe-column field="num" min-width='80px' title="终身买断/元" :edit-render="{ autofocus: '.el-input__inner' }">
                <template slot-scope="scope">
                  <div class="f600 c-cz">{{ scope.row.num }}</div>
                </template>
                <template #edit="{ row, rowIndex, column }">
                  <div class='numInput'>
                    <el-input class='delInput' v-model="row.num" type="number" @change='fGetYfMoney'>
                    </el-input>
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12" v-if="mallInfo.sfFaRadio != '按功能收费'">
            <div class="x-w80 x-p-r-15">门店年费</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.mallAnnualFee"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="11" :offset="1" v-if="mallInfo.sfFaRadio != '按功能收费'">
            <div class="x-w80 x-p-r-15">到期时间</div>
            <el-date-picker size="small" class="x-flex-1"
              :disabled="bykApi.global.fGetPlatform().partnerInfo.data.can_chg_time != 'Y'"
              v-model="mallInfo.expireTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12" v-if="mallInfo.sfFaRadio != '按功能收费'">
            <div class="x-w80 x-p-r-15">终身费用</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.mdMoney"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15 x-col-center" style="height: 32px" :span="11" :offset="1"
            v-if="mallInfo.sfFaRadio != '按功能收费'">
            <el-checkbox v-model="mallInfo.zb_renew">总部统一续费</el-checkbox>
          </el-col>

          <el-col class="x-flex x-m-t-15 x-col-center" style="height: 32px" :span="4">
            <el-checkbox v-model="mallInfo.force_pay_yn" true-label='Y' false-label='N'>强制开通支付</el-checkbox>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="11">
            <div class="x-w100 x-text-r x-p-r-15 must">支付服务商</div>
            <el-input size="small" class="x-flex-1" placeholder="客户自助进件时所属服务商机构号"
              v-model="mallInfo.pay_org_id"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="9">
            <div class="x-w100 x-text-r x-p-r-15 must">支付费率</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="mallInfo.pay_mch_rate"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15 x-col-center" style="height: 32px" :span="24"
            v-if="bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'">
            <div class="x-w80 x-p-r-15">短信签名</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="mallInfo.sms_sign" placeholder="请输入短信签名">
              <el-button slot="append" @click="fSetSms()">保存签名</el-button>
            </el-input>
          </el-col>
        </el-row>
        <div class="dialog-title x-flex x-row-between x-p-t-7 x-m-t-8">
          <div class="x-font-15 f600">价签信息</div>
        </div>
        <el-row>
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80  x-text-c">商户编码</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="mallInfo.elabel_mch_id">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w80  x-text-c">门店编码</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="mallInfo.elabel_mall_id" disabled>
            </el-input>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" size="mini" @click="fEditMall('DJ')">
            冻结
          </el-button>
          <el-button type="info" size="mini" @click="fInnerClose">
            取消
          </el-button>
          <el-button type="danger" size="mini" v-if="modifyOrAddMallType == 'add'" @click="fAddMall">
            确认增加
          </el-button>
          <el-button type="danger" size="mini" v-if="modifyOrAddMallType == 'modify'" @click="fEditMall">
            确认修改
          </el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 支付配置 -->
    <el-dialog :visible.sync="paymentDispose" width="700px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @opened="paymentDisposeOpened" @close="fPaymentDisposeClose">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">支付绑定</div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fPaymentDisposeSave">保存</el-button>
          <el-button type="info" size="small" @click="fPaymentDisposeClose">关闭</el-button>
        </div>
      </div>
      <el-row class="x-flex">
        <el-col class="x-flex x-m-t-15 x-flex-1 x-m-r-30">
          <div class="x-w90 x-text-r x-p-r-15 must">支付方式</div>
          <el-cascader size="small" class="x-flex-1" :options="payMentList" @change="e => { fPayWayChange(e, 'chg') }"
            :props="{ 'value': 'payWay', 'label': 'payWay' }" v-model="paymentInfo.payWay">
            <!-- @change="fPayWayChange" -->
          </el-cascader>
        </el-col>
        <el-col class="x-flex-1 x-flex x-col-center x-m-t-15" style="height: 32px">
          <el-checkbox v-model="paymentInfo.payWayChoose">
            支付宝使用官方支付（可实时到账）
          </el-checkbox>
        </el-col>
      </el-row>
      <div class="x-flex">
        <el-row class="x-flex-1 x-m-r-30">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">老板姓名</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bossName"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90 x-text-r x-p-r-15 must">老板电话</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.bossPhone"></el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90 x-text-r x-p-r-15">备注信息</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo.payRemarks"></el-input>
          </el-col>
        </el-row>
        <div class="x-flex-1">
          <!-- <div id="qrcode" ref="qrCodeUrl"></div> -->
          <div class="x-m-l-20">
            <div class="x-font-15 x-m-b-10">说明：</div>
            <div class="x-font-13 x-m-b-3">1.商户需开通支付宝当面付</div>
            <div class="x-font-13">2.请将二维码发给商户，扫码并授权</div>
          </div>
          <el-button @click="fQRCodeEnlarge" size="small" type="primary" class="x-m-t-20 x-m-l-20">点击生成授权二维码</el-button>
        </div>
      </div>
      <el-row class="x-m-b-20">
        <el-col class="x-flex x-m-t-15 x-p-r-15" :span="12">
          <div class="x-w90 x-text-r x-p-r-15 must">服务商名</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.fwsName"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-15 x-p-r-15" :span="12">
          <div class="x-w90 x-text-r x-p-r-15 must">联系电话</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.fwsPhone"></el-input>
        </el-col>
      </el-row>

      <!-- 中国银联 -->
      <div class="x-m-t-10 bgc-e x-bd-ra-3 x-p-b-15 x-p-r-15 x-m-b-20">
        <div class="x-m-l-18 x-p-t-10 x-font-15 f600 x-flex x-row-between">
          <div>{{ actPayWay.title }}</div>
          <div>
            <span @click="fChgZhType('online')" class="x-m-r-10 f500 x-cur-poi"
              :class="zh_type == 'online' ? 'zh-type' : ''">线上</span>
            <span @click="fChgZhType('offline')" class="f500 x-cur-poi"
              :class="zh_type == 'offline' ? 'zh-type' : ''">线下</span>
          </div>
        </div>
        <el-row>
          <el-col class="x-flex x-m-t-10" :span="24" v-for="item, index in actPayWay.inputList" :key="index">
            <div class="x-w90 x-text-r x-p-r-15" :class="item.must ? 'must' : ''">{{ item.name }}</div>
            <el-input size="small" class="x-flex-1" v-model="paymentInfo[item.filed]"></el-input>
            <el-button v-if="item.clickFn" type="" size="small" class="x-m-l-10" @click="fSetFbWxH5Path">设置微信H5支付路径
            </el-button>
          </el-col>
        </el-row>
      </div>

      <div class="dialog-title" style="padding: 7px 10px;">
        <div class="x-font-15 f600" style="cursor: pointer;" @click="payShowMore = !payShowMore">更多</div>
      </div>
      <el-row v-if="payShowMore" class="x-m-b-15 x-m-t-10">
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">服务商编码</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.payOrgId" placeholder="支付机构下服务商编码"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">商户编码</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.payOrgMchId" placeholder="三方支付机构商户编码"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">微信子商户号</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.wxSubMchId" placeholder="微信子商户号"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">公众号appId</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.wxAppId" placeholder="微信公众号appid"></el-input>
        </el-col>
        <el-col class="x-flex x-m-t-10" :span="24">
          <div class="x-w120 x-text-r x-p-r-15 must">小程序appId</div>
          <el-input size="small" class="x-flex-1" v-model="paymentInfo.wxMinAppId" placeholder="微信小程序appId"></el-input>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 二维码放大 -->
    <el-dialog title="" :visible.sync="QRCodeEnlargeDialog" width="635px" @opened="maxQRCodeOpened" top="8vh"
      :show-close="false">
      <div style="width: 635px; height: 600px">
        <div id="qrcodeMax" ref="qrCodeUrlMax"></div>
      </div>
    </el-dialog>
    <!-- 自助注册二维码弹框 -->
    <el-dialog title="" :visible.sync="selfRegDialog" width="900px" top="5vh" :show-close="false">
      <div class="x-flex x-row-between x-m-t-20 x-p-b-15 x-bd-bottom">
        <div class="left-line x-font-15 f600">生成商户注册二维码</div>
        <div class="x-flex">
          <el-button type="info" size="small" @click="selfRegDialog = false">关闭</el-button>
        </div>
      </div>
      <!-- <div v-if=" bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'" style="width: 860px; height: 565px; flex-direction: column" class="x-flex x-row-center x-col-center x-p-40">
        <img src="../../src/assets/img/QRCode.png" alt="" style="width: 300px; margin-top: 70px" />
        <div class="x-m-50">
          <div class="x-font-15 f600">流程说明：</div>
          <div class="x-m-t-10 x-m-b-5">
            1：扫描二维码，核对信息，点击生成二维码
          </div>
          <div>2：将生成的二维码发给商户,商户自行提交注册</div>
        </div>
      </div> -->
      <div style="width: 860px; height: 565px; flex-direction: column" class="x-flex x-row-center x-col-center x-p-40">
        <div id="selfQr" ref="selfQrUrlMax"></div>
        <div class="x-m-t-10 x-m-b-5 x-font-16">将生成的二维码发给商户,商户自行提交注册</div>
      </div>
    </el-dialog>
    <!-- 清除所有数据 -->
    <el-dialog title="" :visible.sync="cancelAllDataDialog" width="550px" :close-on-click-modal='false'>
      <div style="color: #f62515">
        <div class="x-font-18 f600">确认清除所有门店所有数据？</div>
        <div class="x-flex x-col-start x-m-t-20 x-font-16 f600">
          <div>特别提示：</div>
          <div class="x-flex-1">
            <div>删除数据为物理删除，删除后无法找回原有的数据！！！</div>
            <div class="x-m-t-10">请谨慎操作，一切后果自行负责！！！</div>
          </div>
        </div>
      </div>
      <div class="x-m-t-20 x-font-16 f600" style="color: #242424 !important">
        门店名：{{ this.mallDisposeInfo.mall_name }} &nbsp;&nbsp;&nbsp;&nbsp;
        手机号：{{ this.mallDisposeInfo.user_phone }}
      </div>
      <div class="x-m-t-20 x-m-b-20">
        <el-radio v-model="cancelDataTypeIdx" label="1">
          删除业务数据
        </el-radio>
        <el-radio v-model="cancelDataTypeIdx" label="2">
          仅保留基本档案
        </el-radio>
        <el-radio v-model="cancelDataTypeIdx" label="3">
          删除全部数据
        </el-radio>
      </div>
      <div v-if="cancelDataTypeIdx == 1">
        <el-date-picker v-model="cancelDataTime" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 380px">
        </el-date-picker>
      </div>
      <div class="x-flex x-m-t-20 x-m-b-20">
        <div v-if="
          bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'
        ">
          <el-input v-model="partnerPwd" placeholder="请输入合作伙伴后台" size="large" style="width: 380px" type="password">
          </el-input>
        </div>
        <div class='x-flex' v-else>
          <el-input v-model="clearYzm" placeholder="请输入验证码" size="large" style="width: 380px" type="text">
          </el-input>
          <el-button class='x-w120 x-m-l-10' type="primary" @click.native="sendEmail({ oper: 'SEND_SMS_YZM' })">
            <span v-show="showTime">获取验证码</span>
            <span v-show="!showTime">{{ sendTime }}秒</span>
          </el-button>
        </div>

      </div>
      <div class="x-flex x-row-right">
        <el-button size="small" type="info" @click="cancelAllDataDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="fResetAllData">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 商户汇总 -->
    <el-dialog :visible.sync="mchTotalPop" width="400px" :close-on-click-modal="false">
      <div class="x-w100p x-text-c f600 x-font-16">商户汇总</div>
      <div class="x-m-t-30" style="height: 65vh;overflow: auto;">
        <!-- <div class="x-font-16 x-m-t-10">商务热线</div>
        <div class="x-m-t-20 x-m-b-30 x-font-21 c-primary">400-862-5828</div>
        <div class="x-m-b-30">官方网址：http://www.sanmipos.com</div> -->
        <div class="x-font-16 x-p-b-20 x-flex" v-for="(item, index) in mchTotalInfo">
          <div class='x-flex-1'>{{ item.user_ip }}</div>
          <div class='x-flex-1'>{{ item.user_count }}</div>
        </div>
      </div>
    </el-dialog>

    <!-- 电子价签 -->
    <el-dialog :visible.sync="dzjqPop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="dzjqClose">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">电子价签</div>
        <div class="x-flex">
          <!-- <el-button type="danger" size="small" @click="fPaymentDisposeSave">保存</el-button> -->
          <!-- <el-button style="width: 60px;" type="info" size="small" @click="dzjqClose">关闭</el-button> -->
          <div class="x-lh-32" @click="dzjqClose">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <div>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="5">
            <div class="x-w70  x-text-l">门店ID</div>
            <div class="x-lh-32">{{ mall_id }}</div>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w70  x-text-c">价签ID</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="dzjqInfo.dzjq_id"
              @change="dzjqInfo.dzjq_name = dzjqInfo.dzjq_id + '价签'">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="9">
            <div class="x-w70  x-text-c">价签名称</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="dzjqInfo.dzjq_name">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15 x-row-right" :span="2">
            <el-button style="width: 60px;" type="danger" size="small" @click="fElabelOper('ADD')">增加</el-button>
          </el-col>
        </el-row>
        <el-row class="x-p-t-20">
          <el-col>
            <vxe-table border highlight-hover-row height="380px" :data="dzjqData" align="center" ref="xTable1"
              style="width: 100%;">
              <vxe-column field="RC" width='80px' title="序号"></vxe-column>
              <vxe-column field="label_id" min-width='90px' title="价签ID"></vxe-column>
              <vxe-column field="label_name" min-width='90px' title="价签名称"></vxe-column>
              <vxe-column field="mall_id" min-width='90px' title="门店编码"></vxe-column>
              <vxe-column field="chg_time" min-width='90px' title="修改时间"></vxe-column>
              <vxe-column fixed="right" title="操作" width="70px" style="margin-bottom: 20px">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="" style="color: #f56c6c"
                    @click="fElabelOper('DEL', scope.row.label_id, scope.row.label_name)">
                    删除
                  </el-button>
                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
        </el-row>
        <div class="x-flex x-row-between x-p-t-10" style="margin-right: -10px;">
          <div class="x-flex ">
            <el-radio v-model="dzjqRadio" label="0001" class="x-m-l-20 x-m-r-5">全部</el-radio>
            <el-radio v-model="dzjqRadio" label="本店" class="x-m-l-5 x-m-r-20">本店</el-radio>
            <div style="width: 300px">
              <el-input placeholder="" v-model="dzjqSearchStr" size="medium" class="x-m-r-12 x-flex-1">
                <el-button slot="append" @click="fGetDzjqList(1)">搜索</el-button>
                <!-- <template slot="append">搜索</template> -->
              </el-input>
            </div>
          </div>
          <el-pagination background layout="prev, pager, next" :total="Number(dzjqTR)" :page-size='20'
            @current-change="fGetDzjqList" :current-page="dzjqNowPage">
          </el-pagination>
        </div>

      </div>
    </el-dialog>
    <!-- 云打印机 -->
    <el-dialog :visible.sync="ydyjPop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="ydyjPop = false">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">云打印机</div>
        <div class="x-flex">
          <!-- <el-button type="danger" size="small" @click="fPaymentDisposeSave">保存</el-button> -->
          <!-- <el-button style="width: 60px;" type="info" size="small" @click="ydyjPop=false">关闭</el-button> -->
          <div class="x-lh-32" @click="ydyjPop = false">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <div>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="6">
            <div class="x-w70  x-text-l">门店ID</div>
            <div class="x-lh-32">{{ mall_id }}</div>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="12">
            <div class="x-w70  x-text-l">门店名称</div>
            <div class="x-lh-32">{{ mall_name }}</div>
          </el-col>
          <!-- <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w70  x-text-c">价签ID</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.ydyj_id"
              @change="ydyjInfo.ydyj_name = ydyjInfo.ydyj_id+'价签'">
            </el-input>
          </el-col> -->
          <!-- <el-col class="x-flex x-m-t-15" :span="9">
            <div class="x-w70  x-text-c">价签名称</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.ydyj_name">
            </el-input>
          </el-col> -->
          <el-col class="x-flex x-m-t-15 x-row-right" :span="6">
            <el-button style="width: 80px;" type="danger" size="small" @click="fYdyjOper('OPEN')">增加</el-button>
          </el-col>
        </el-row>
        <el-row class="x-p-t-20">
          <el-col>
            <vxe-table border highlight-hover-row height="380px" :data="ydyjData" align="center" ref="xTable1"
              style="width: 100%;">
              <vxe-column field="RC" width='80px' title="序号"></vxe-column>
              <vxe-column field="prt_type" min-width='90px' title="类型">
                <template slot-scope="scope">
                  <div>{{ scope.row.prt_type == 'bill' ? '小票' : '标签' }}</div>
                </template>
              </vxe-column>
              <vxe-column field="def_yn" min-width='90px' title="默认">
                <template slot-scope="scope">
                  <div>{{ scope.row.def_yn == 'Y' ? '是' : '' }}</div>
                </template>
              </vxe-column>
              <vxe-column field="state" min-width='90px' title="WEB打印"></vxe-column>
              <vxe-column field="prt_id" min-width='160px' title="打印机ID"></vxe-column>
              <vxe-column field="prt_name" min-width='120px' title="打印机名称"></vxe-column>
              <vxe-column field="user_memo" min-width='120px' title="备注"></vxe-column>
              <vxe-column field="mch_token" min-width='300px' title="授权TOKEN"></vxe-column>
              <vxe-column field="mall_id" min-width='90px' title="门店编码"></vxe-column>
              <vxe-column field="chg_time" min-width='200px' title="修改时间"></vxe-column>
              <vxe-column fixed="right" title="操作" width="80px" style="margin-bottom: 20px">
                <template slot-scope="scope">
                  <div class='x-flex'>
                    <el-button type="text" size="mini"
                      @click="fYdyjOper('OPEN_EDIT', scope.row.prt_id, scope.row.prt_name)">
                      修改
                    </el-button>
                    <el-button type="text" size="mini" style="color: #f56c6c"
                      @click="fYdyjOper('SQ', scope.row.prt_id, scope.row.prt_name, scope.row.mch_token)">
                      授权
                    </el-button>
                  </div>

                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
        </el-row>
        <div class="x-flex x-row-between x-p-t-10" style="margin-right: -10px;">
          <div class="x-flex ">
            <el-radio v-model="ydyjRadio" label="0001" class="x-m-l-20 x-m-r-5">全部</el-radio>
            <el-radio v-model="ydyjRadio" label="本店" class="x-m-l-5 x-m-r-20">本店</el-radio>
            <div style="width: 300px">
              <el-input placeholder="打印机编码,打印机名称,制造商" v-model="ydyjSearchStr" size="medium" class="x-m-r-12 x-flex-1">
                <el-button slot="append" @click="fGetYdyjList(1)">搜索</el-button>
                <!-- <template slot="append">搜索</template> -->
              </el-input>
            </div>
          </div>
          <el-pagination background layout="prev, pager, next" :total="Number(ydyjTR)" :page-size='20'
            @current-change="fGetDzjqList" :current-page="ydyjNowPage">
          </el-pagination>
        </div>

      </div>
    </el-dialog>
    <!-- 云打印机编辑 -->
    <el-dialog :visible.sync="ydyjEditPop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="ydyjEditPop = false">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">{{ ydyjEditPopTitle }}</div>
        <div class="x-flex">
          <div class="x-lh-32" @click="ydyjEditPop = false">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <div class="x-p-r-15">
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" style="flex-shrink: 1;" :span="8">
            <div class="x-w90  x-text-r x-p-r-10">制造厂商</div>
            <el-select size="small" class="x-flex-1" ref="select" v-model="ydyjInfo.prt_maker">
              <el-option label="佳博" value="gprinter"></el-option>
            </el-select>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w90  x-text-r x-p-r-10">票据类型</div>
            <el-select size="small" class="x-flex-1" ref="select" v-model="ydyjInfo.prt_type">
              <el-option label="小票" value="bill"></el-option>
              <el-option label="标签" value="label"></el-option>
            </el-select>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w90  x-text-r x-p-r-10">纸张宽度</div>
            <el-select size="small" class="x-flex-1" ref="select" v-model="ydyjInfo.paper_width">
              <el-option label="58mm" value="32"></el-option>
              <el-option label="80mm" value="48"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w90  x-text-r x-p-r-10">终端编号</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.prt_id"
              :disabled='ydyjEditPopTitle == "修改"'>
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="16">
            <div class="x-w90  x-text-r x-p-r-10">打印机名</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.prt_name">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="8">
            <div class="x-w90  x-text-r x-p-r-10">打完走纸</div>
            <el-input size="small" class="x-flex-1" type="number" v-model="ydyjInfo.feed_line">
            </el-input>
          </el-col>

          <el-col class="x-flex x-m-t-20 x-row-right" :offset='4' :span="4">
            <div class="x-w70 x-text-r x-p-r-6">切纸</div>
            <el-switch v-model="ydyjInfo.cut_paper" active-color="#409EFF" inactive-color="#808080" active-value='Y'
              inactive-value='N'>
            </el-switch>
          </el-col>
          <el-col class="x-flex x-m-t-20 x-row-right" :span="4">
            <div class="x-w70 x-text-r x-p-r-6">默认</div>
            <el-switch v-model="ydyjInfo.def_yn" active-color="#409EFF" inactive-color="#808080" active-value='Y'
              inactive-value='N'>
            </el-switch>
          </el-col>
          <el-col class="x-flex x-m-t-20 x-row-right" :span="4">
            <div class="x-w70 x-text-r x-p-r-6">启用</div>
            <el-switch v-model="ydyjInfo.state" active-color="#409EFF" inactive-color="#808080" active-value='启用'
              inactive-value='停用'>
            </el-switch>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">备注信息</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.user_memo">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">模板编码</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.template_id">
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="x-p-r-15" v-if="ydyjInfo.prt_type == 'bill'">

        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">票头LOGO</div>
            <!-- <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.logo_url">
            </el-input> -->
            <div @mouseover="proImg[0].imgEdit = true" @mouseleave="proImg[0].imgEdit = false"
              class="x-w140 x-h140 x-rela  x-bd x-bd-ra-5  image x-rela">
              <el-image class="x-w140 x-h140" v-show="!bykApi.smCom.fSmIsEmpty(ydyjInfo.logo_url)"
                :src="bykApi.smCom.fSmIsEmpty(ydyjInfo.logo_url) ? '' : ydyjInfo.logo_url">
                <div slot="error" class="x-flex x-w140 x-h140 x-row-center c-80">
                  <!-- <i class="el-icon-picture-outline"></i> -->加载中...
                </div>
              </el-image>
              <el-upload class="shangchuan x-flex x-row-center" ref="logoImg" action="https://u.91byk.com/"
                :data="ossParams" :auto-upload='false' :show-file-list="false"
                :on-change="file => { fImgChg(file, 'pro', 0) }" accept="image/jpeg,image/png">
                <div v-show="bykApi.smCom.fSmIsEmpty(ydyjInfo.logo_url)" class="x-flex x-w140 x-h140 x-row-center c-80">
                  暂无图片
                </div>
              </el-upload>

              <div v-show="proImg[0].imgEdit == true && !bykApi.smCom.fSmIsEmpty(ydyjInfo.logo_url)"
                class="x-abso x-w140 x-h140 x-rela  x-bd x-bd-ra-5 x-top-0 x-flex x-row-around"
                style="background-color: rgba(0, 0, 0, 0.7); cursor: pointer">
                <!-- <i class="el-icon-zoom-in c-f x-font-20"
                  @click="dialogVisible = true;dialogImageUrl=ydyjInfo.logo_url"></i> -->
                <i class="el-icon-delete c-f x-font-20"
                  @click='proImg[0].url = proImg[0].src = ydyjInfo.logo_url = ydyjInfo.pro_img_src = ""; proImg[0].file = ""'></i>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">票据抬头</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.bill_title">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">票据结尾</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.bill_end">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">一维码内容</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.bar_code">
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="24">
            <div class="x-w90  x-text-r x-p-r-10">二维码内容</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="ydyjInfo.qr_code">
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="x-flex x-row-between x-p-t-30 x-p-b-15 x-p-r-25" style="margin-right: -10px;">
        <div class="x-p-l-10">
          <el-checkbox v-model="ydyjInfo.sync_maker" true-label="N" false-label="Y">授权模式（打印机归属在客户自己账号下）</el-checkbox>
        </div>
        <div>
          <el-button style="width: 80px;" size="small" @click="fYdyjOper('DEL')">删除</el-button>
          <el-button style="width: 80px;" type="danger" size="small" @click="fYdyjOper('SAVE')">保存</el-button>
        </div>
      </div>
      <!-- https://mobile.poscom.cn/frontmanage/openoauth/authorize?code=3DC67B5F32A9304AA461B605BF5EFF6C&state= {"appType":"smSell","mchUrl":"http://8.142.32.47/smSellAdmin/adminApi","mchId":"13800000005"} -->
    </el-dialog>
    <!-- 摄像头 -->
    <el-dialog :visible.sync="jkPop" width="800px" :show-close="false" :close-on-click-modal="false" class="add-dialog"
      @close="jkClose">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">摄像头列表</div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="sbsqPop = true">设备授权</el-button>
          <el-button style="width: 60px;" type="info" size="small" @click="jkClose">关闭</el-button>
          <!-- <div class="x-lh-32" @click="jkClose">
            <i class="el-icon-close "></i>
          </div> -->
        </div>
      </div>
      <div>
        <el-row :gutter="10">
          <el-col class="x-flex x-m-t-15" :span="4">
            <div class=" x-text-l">门店ID：</div>
            <div class="x-lh-32">{{ mall_id }}</div>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="6">
            <div class=" x-text-c">序列号：</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="jkInfo.jkId">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="5">
            <div class=" x-text-c">验证码：</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="jkInfo.jkPsw">
            </el-input>
          </el-col>
          <el-col class="x-flex x-m-t-15" :span="7">
            <div class=" x-text-c">到期时间：</div>
            <el-date-picker size="small" class="x-flex-1" v-model="jkInfo.exTime" type="date" placeholder="选择日期"
              :clearable="false" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>

          <el-col class="x-flex x-m-t-15 x-row-right" :span="2">
            <el-button style="width: 60px;" type="danger" size="small" @click="fJklOper('ADD')">增加</el-button>
          </el-col>
        </el-row>
        <el-row class="x-p-t-20">
          <el-col>
            <vxe-table border highlight-hover-row height="380px" :data="jkData" align="center" ref="xTable1"
              style="width: 100%;">
              <vxe-column type="seq" width='80px' title="序号"></vxe-column>
              <vxe-column field="camera_id" min-width='90px' title="摄像头ID"></vxe-column>
              <vxe-column field="camera_name" min-width='120px' title="摄像头名称"></vxe-column>
              <vxe-column field="camera_psw" min-width='90px' title="摄像头密码"></vxe-column>
              <vxe-column field="mall_id" min-width='90px' title="门店编码"></vxe-column>
              <vxe-column field="exp_time" min-width='180px' title="到期时间"></vxe-column>
              <vxe-column field="chg_time" min-width='180px' title="修改时间"></vxe-column>
              <vxe-column fixed="right" title="操作" width="140px" style="margin-bottom: 20px">
                <template slot-scope="scope">
                  <div class="x-flex">
                    <div class="x-p-r-10">
                      <el-button type="text" size="mini" @click="" style="color: #2c8ff2"
                        @click="fJklOper('SQ', scope.row.camera_id)">
                        添加白名单
                      </el-button>
                    </div>

                    <el-button type="text" size="mini" @click="" style="color: #f56c6c"
                      @click="fJklOper('DEL', scope.row.camera_id, scope.row.camera_name, scope.row.camera_psw)">
                      删除
                    </el-button>
                  </div>

                </template>
              </vxe-column>
            </vxe-table>
          </el-col>
        </el-row>
        <div class="x-flex x-row-between x-p-t-10" style="margin-right: -10px;">
          <div class="x-flex ">
            <el-radio v-model="jkRadio" label="0001" class="x-m-l-20 x-m-r-5">全部</el-radio>
            <el-radio v-model="jkRadio" label="本店" class="x-m-l-5 x-m-r-20">本店</el-radio>
            <div style="width: 300px">
              <el-input placeholder="" v-model="jkSearchStr" size="medium" class="x-m-r-12 x-flex-1">
                <el-button slot="append" @click="fGetDzjqList(1)">搜索</el-button>
                <!-- <template slot="append">搜索</template> -->
              </el-input>
            </div>
          </div>
          <el-pagination background layout="prev, pager, next" :total="Number(jkTR)" :page-size='20'
            @current-change="fGetDzjqList" :current-page="jkNowPage">
          </el-pagination>
        </div>

      </div>
    </el-dialog>
    <el-dialog :visible.sync="sbsqPop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="sbsqPop = false">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">设备授权</div>
        <div class="x-flex">
          <!-- <el-button type="danger" size="small" @click="">设备授权</el-button> -->
          <!-- <el-button style="width: 60px;" type="info" size="small" @click="jkClose">关闭</el-button> -->
          <div class="x-lh-32" @click="sbsqPop = false">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <div class="x-flex x-p-40">
        <div class="x-flex-1">
          <div class="x-p-b-40">
            <el-steps style="height: 200px;" direction="vertical" :active="4">
              <el-step title="客户注册萤石账号并绑定摄像头"></el-step>
              <el-step title="将授权链接或二维码发给客户进行授权"></el-step>
              <el-step title="进入授权链接后登录萤石云的账号密码"></el-step>
              <el-step title="将客户提供的摄像头序列号和验证码添加到系统"></el-step>
            </el-steps>
          </div>
          <img src="http://www.sanmipos.com/smsoft/partnerAdmin/static/img/jk-sqlb.f04c10d.png" width="100%"
            height="100%">
        </div>

        <div class="x-flex-1 x-text-c x-m-l-20 x-p-t-40 x-p-b-40" style="font-size: 16px;">
          <div>授权链接</div>
          <div class="x-p-t-30 x-p-b-30">
            <img src="../assets/img/yssqlj.png" width="200px" height="200px">
          </div>
          <a class="x-p-l-10 x-p-r-20" style="text-decoration: underline;color: #1C6BD5;" target='_blank'
            href="https://open.ys7.com/oauth2/trust/device?client_id=6f7dda79c4ec4a79b99045f52a88505a">
            https://open.ys7.com/oauth2/trust/device?client_id=6f7dda79c4ec4a79b99045f52a88505a
          </a>


        </div>
      </div>

    </el-dialog>
    <el-dialog :visible.sync="ydyjSbsqPop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="ydyjSbsqPop = false">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">设备授权</div>
        <div class="x-flex">
          <!-- <el-button type="danger" size="small" @click="">设备授权</el-button> -->
          <!-- <el-button style="width: 60px;" type="info" size="small" @click="jkClose">关闭</el-button> -->
          <div class="x-lh-32" @click="ydyjSbsqPop = false">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <div class="x-flex x-p-40">
        <div class="x-flex-1">
          <div class="x-p-b-40">
            <div class='x-p-b-20  x-font-20' style="color:red">当打印机归属在客户自己账号下时使用授权模式</div>
            <el-steps style="height: 150px;" direction="vertical" :active="4">
              <el-step title="客户注册佳博账号"></el-step>
              <el-step title="将授权链接或二维码发给客户进行授权"></el-step>
              <el-step title="点击获取授权按钮"></el-step>
            </el-steps>
          </div>
          <img src="../assets/img/ydyj.png" width="100%" height="100%">
          <div class='x-p-b-10 x-p-t-10'>佳博账号注册</div>
          <div class='x-p-b-20'>电脑端
            <a class="x-p-l-10 x-p-r-20" style="text-decoration: underline;color: #1C6BD5;" target='_blank'
              href="https://cp.poscom.cn/login?act=reg">
              https://cp.poscom.cn/login?act=reg
            </a>
          </div>
          <div class='x-p-b-20'>手机端
            <a class="x-p-l-10 x-p-r-20" style="text-decoration: underline;color: #1C6BD5;" target='_blank'
              href="https://mobile.poscom.cn">
              https://mobile.poscom.cn
            </a>
          </div>
        </div>

        <div class="x-flex-1 x-text-c x-m-l-20 x-p-t-40 x-p-b-40" style="font-size: 16px;">
          <div>授权链接</div>
          <div class='x-w100p x-flex x-row-center x-p-b-20 x-p-t-20'>
            <div style="width: 200px; height: 200px">
              <div id="qrcodeMax1" ref="qrCodeUrlMax1"></div>
            </div>
          </div>
          <a class="x-p-l-10 x-p-r-20" style="text-decoration: underline;color: #1C6BD5;" target='_blank'
            :href="ydyjSbsqUrl">
            {{ ydyjSbsqUrl }}
          </a>
          <div class='x-p-t-40'>
            <el-button type="danger" v-if="isSq == 'N'" style="width: 100px;" size="small"
              @click="fYdyjOper('SET_TOKEN')">获取授权</el-button>
            <el-button v-if="isSq == 'Y'" style="width: 100px;" size="small"
              @click="fYdyjOper('UN_SET_TOKEN')">取消授权</el-button>
          </div>
        </div>
      </div>

    </el-dialog>
    <el-dialog :visible.sync="showMorePop" width="800px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" @close="showMorePop = false">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-15 f600">自动安装</div>
        <div class="x-flex">
          <!-- <el-button type="danger" size="small" @click="">设备授权</el-button> -->
          <!-- <el-button style="width: 60px;" type="info" size="small" @click="jkClose">关闭</el-button> -->
          <div class="x-lh-32" @click="showMorePop = false">
            <i class="el-icon-close "></i>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div>
        <el-row :gutter="10" class="x-p-t-20">
          <el-col class="x-flex " :span="6">
            <div class="x-w70  x-text-l">软件名称</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="autoJsonInfo.soft_name" @change="">
            </el-input>
          </el-col>
          <el-col class="x-flex " :span="6">
            <div class="x-w70  x-text-c">软件版本</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="autoJsonInfo.soft_ver" @change="">
            </el-input>
          </el-col>
          <el-col class="x-flex " :span="7">
            <div class="x-w70  x-text-c">下载链接</div>
            <el-input size="small" class="x-flex-1" type="text" v-model="autoJsonInfo.down_url" @change="">
            </el-input>
          </el-col>
          <el-col class="x-flex x-lh-32" :span="3">
            <el-checkbox v-model="autoJsonInfo.enable_yn" false-label="N" true-label="Y">是否启用</el-checkbox>
          </el-col>
          <el-col class="x-flex  x-row-right" :span="2">
            <el-button style="width: 60px;" type="danger" size="small" @click="fAutoJsonOper('ADD', autoJsonInfo)">增加
            </el-button>
          </el-col>
        </el-row>
      </div>
      <el-row class="x-p-t-20">
        <el-col>
          <vxe-table border highlight-hover-row height="380px" :data="autoJson" align="center" ref="xTable1"
            style="width: 100%;">
            <vxe-column type="seq" width='80px' title="序号"></vxe-column>
            <vxe-column field="soft_name" min-width='90px' title="软件名称"></vxe-column>
            <vxe-column field="soft_ver" min-width='90px' title="软件版本"></vxe-column>
            <vxe-column field="down_url" min-width='120px' title="下载链接">
              <!-- <template #default="{ row }">
                <el-input  size="small" class="x-flex-1" type="textarea" v-model="row.down_url" @change="">
                </el-input>
              </template> -->

            </vxe-column>
            <vxe-column field="enable_yn" min-width='90px' title="是否启用"
              :edit-render="{ autofocus: '.el-input__inner' }">
              <template #default="{ row }">
                <el-select size="small" class="x-w100p" ref="select" v-model="row.enable_yn">
                  <el-option label="Y" value="Y"></el-option>
                  <el-option label="N" value="N"></el-option>
                </el-select>
              </template>
            </vxe-column>
            <vxe-column fixed="right" title="操作" width="70px" style="margin-bottom: 20px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="" style="color: #f56c6c"
                  @click="fAutoJsonOper('DEL', scope)">
                  删除
                </el-button>
              </template>
            </vxe-column>
          </vxe-table>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="x-p-t-20">
        <el-col class="x-flex  x-row-left x-lh-32" :span="12">
          说明: 软件登录时，将自动下载并安装列表中启用的软件
        </el-col>
        <el-col class="x-flex  x-row-right" :span="12">
          <el-button style="width: 80px;" type="danger" size="small" @click="fAutoAz('USER_LIST')">保存
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  import base64 from '../../src/common/global/base64.js';
  import adr from "../assets/js/adr.js";
  import QRCode from "qrcodejs2";
  import md5 from 'js-md5'
  import {
    fSmUpLoadImg
  } from '../../src/common/global/fSmUpLoadImg.js';
  import {
    Loading
  } from 'element-ui';
  export default {
    mixins: [fSmUpLoadImg],
    data() {
      return {
        ossParams: {},
        //主图
        proImg: [{
          url: '',
          src: '',
          file: '',
          imgEdit: false,
        }],

        sbsqPop: false,
        showQcSj: false,
        showKhdBbTs: false,
        showJmmd: false,
        showZywz: false,
        showKyjmd: false,
        showXxtztx: false,
        showFpgg: false,
        showZdmk: false,
        //电子价签参数
        dzjqRadio: '本店',
        dzjqSearchStr: '',
        dzjqPop: false, //电子价签
        dzjqData: [],
        dzjqNowPage: 1,
        dzjqTR: 0,
        dzjqInfo: {
          dzjq_id: '',
          dzjq_name: '',
        },
        //云打印机参数
        ydyjSbsqUrl: '',
        isSq: '',
        ydyjSbsqPop: false,
        ydyjRadio: '本店',
        ydyjSearchStr: '',
        ydyjPop: false, //云打印机
        ydyjEditPop: false,
        ydyjEditPopTitle: '新增',
        ydyjData: [],
        ydyjNowPage: 1,
        ydyjTR: 0,
        ydyjInfo: {
          prt_id: "",
          prt_maker: "",
          prt_name: "",
          prt_type: "",
          prt_port_type: "",
          prt_port: "",
          mch_token: "",
          def_yn: "",
          template_id: "",
          logo_url: "",
          bill_title: "",
          bill_end: "",
          bar_code: "",
          qr_code: "",
          paper_width: "",
          feed_line: "",
          cut_paper: "",
          sync_maker: '',
          state: "",
          user_memo: "",
        },
        //摄像头参数
        jkRadio: '本店',
        jkSearchStr: '',
        jkPop: false, //电子价签
        jkData: [],
        jkNowPage: 1,
        jkTR: 0,
        jkInfo: {
          jkId: '',
          jkPsw: '',
          exTime: new Date(new Date().getTime() + 360 * 24 * 60 * 60 * 1000)
        },
        payShowMore: false,
        shen: "",
        shi: "",
        qu: "",
        radio: "条件查询",
        merInputVal: "",
        searchAddressVal: "", //
        searchTypeVal: "商户", //
        // searchSortVal: "注册时间降序", //
        checked: true, //
        buySoftware: false, // 购买软件
        buySoftwareMoney: "", // 购买软件的金额
        goBuyDialog: false, // 购买软件付款界面
        buySuccess: false, // 付款成功的界面
        buyFail: false, // 付款失败的界面
        addMerchant: false, // 增加商户
        merchantAddOrEdit: "ADD", //  判断增加还是修改商户的标志
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        paymentDispose: false, // 支付配置
        mallDispose: false, // 配置门店
        mallDisposeInfo: {}, // 全局的点击操作的 商户信息
        innerModifyMall: false, // 内层的门店修改对话框
        innerModifyMallTitle: "", // 内层的门店修改对话框的标题
        modifyOrAddMallType: "", // 判断增加还是修改的标志
        buyType: "",
        forceUpdateOtion: [{
            name: '是',
            val: 'Y'
          },
          {
            name: '否',
            val: 'N'
          },
        ],
        timeRadio: '全部',
        time: [this.bykApi.timeHelper.manyDaysAgo(30, 3) + ' 00:00:00', this.bykApi.timeHelper.manyDaysAgo(0, 3) +
          ' 23:59:59'
        ],
        startTime: this.bykApi.timeHelper.manyDaysAgo(30, 3),
        overTime: this.bykApi.timeHelper.manyDaysAgo(0, 3),
        lastTime: this.bykApi.timeHelper.manyDaysAgo(0, 3),
        pageSize: 50,
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        shInfo: {
          mchSrvIp: this.bykApi.global.fGetPlatform().partnerInfo.data.fwq_ip,
          partnerPhone: this.bykApi.global.fGetPlatform().partnerInfo.phone,
          shEdition: "零售5.0", // 软件版本
          shPhone: "", // 手机号码
          shLxName: "", // 联系人名
          shUserType: "标准用户", // 用户类型
          shMallName: "", // 门店名称
          shIndustry: "便利店", // 所属行业
          shMainMarketing: "", // 主要经营
          // shMallAddress: "", // 门店地址
          shMallDetailAddress: "", // 门店详细地址
          shRemarks: "", // 备注信息
          shHomeUrl: "", // 主页网址
          jm_mall_can_use_num: "0",
          shAdUrl: "", // 广告网址
          shAdChoose: false, // 副屏广告统一管理是否选中
          wsYn: false,
          shCustomModelName: "", // 自定模块名
          shCustomModelUrl: "", // 自定网址
          shCustomModelChoose: false, // 自定模块打开独立浏览
          shAllCost: "299", // 全部费用
          mustPayCount: '3',
          shCanUseComputed: "3", // 可用电脑
          shShopMallExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 商城到期
          shOrderGoodsExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 订货到期
          org_ak: '',
          org_sk: '',
        },
        // payWayType: "贝友PAY", // 支付绑定
        actPayWay: {},
        payMentList: [{
            payWay: '尚米PAY',
            title: "尚米PAY",
            inputList: [{
                name: '商户编码',
                filed: 'app_id',
                must: true,
              },
              {
                name: '门店编码',
                filed: 'app_mall_id',
                must: true,
              }
            ],
          },
          {
            payWay: '嘉联支付',
            title: "嘉联支付",
            inputList: [{
                name: '机构编码',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户编码',
                filed: 'app_secret',
                must: true,
              },
            ],
          },

          {
            payWay: '银商支付',
            title: "银商支付绑定参数",
            inputList: [{
                name: 'appId',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户号',
                filed: 'app_secret',
                must: true,
              },
              {
                name: '终端号',
                filed: 'app_mall_id',
                must: true,
              }
            ],

          },
          {
            payWay: '拉卡拉',
            title: "拉卡拉绑定参数",
            inputList: [{
                name: 'appId',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户号',
                filed: 'app_secret',
                must: true,
              },
              {
                name: '终端号',
                filed: 'app_mall_id',
                must: true,
              }
            ],

          },
          {
            payWay: '京东支付',
            title: "京东支付绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '店铺编号',
                filed: 'app_mall_id',
                must: true,
              },
              {
                name: '代理秘钥',
                filed: 'app_secret',
                must: true,
              }
            ],

          },
          {
            payWay: '河马付',
            title: "河马付绑定参数",
            inputList: [{
                name: 'appId',
                filed: 'app_id',
                must: true,
              },
              {
                name: 'subAppId',
                filed: 'app_secret',
                must: true,
              },
              {
                name: 'storeNo',
                filed: 'app_mall_id',
                must: true,
              }
            ],

          },
          {
            payWay: '信联付',
            title: "信联付绑定参数",
            inputList: [{
                name: 'appId',
                filed: 'app_id',
                must: true,
              },
              {
                name: 'appSercet',
                filed: 'app_secret',
                must: true,
              },
            ],

          },
          {
            payWay: '平安银行',
            title: "平安银行绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '注册号',
                filed: 'app_secret',
                must: true,
              },
            ],

          },
          {
            payWay: '中国银联',
            title: "中国银联绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '支付秘钥',
                filed: 'app_secret',
                must: true,
              },
              {
                name: '终端号',
                filed: 'app_mall_id',
                must: true,
              }
            ],

          }, {
            payWay: '创识农行',
            title: "创识农行绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '支付秘钥',
                filed: 'prv_key',
                must: true,
              },
              // {
              //   name: '终端号',
              //   filed: 'app_mall_id',
              //   must: false,
              // }
            ],

          }, {
            payWay: '通联支付',
            title: "通联支付绑定参数",
            inputList: [{
                name: 'appid',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户号',
                filed: 'app_mall_id',
                must: true,
              },
              {
                name: '支付秘钥',
                filed: 'prv_key',
                must: true,
              },
            ],

          },


          // {
          //   payWay: '国铁吉讯',
          //   title: "国铁吉讯绑定参数",
          //   inputList: [
          //     {
          //       name: 'AppId',
          //       filed: 'app_id',
          //       must: true,
          //     },
          //     {
          //       name: 'AppSecret',
          //       filed: 'app_secret',
          //       must: true,
          //     }
          //   ],

          // },
          {
            payWay: '微邮付',
            title: "微邮付绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '支付秘钥',
                filed: 'app_secret',
                must: true,
              },
            ],

          },
          {
            payWay: '付呗',
            title: "付呗绑定参数",
            inputList: [{
                name: '门店 ID',
                filed: 'app_mall_id',
                must: true,
                clickFn: true,
              },
              {
                name: '付呗 AppId',
                filed: 'app_id',
                must: true,
              },
              {
                name: 'AppSecret',
                filed: 'app_secret',
                must: true,
              }
            ],

          },
          {
            payWay: '随行付',
            title: "随行付绑定参数",
            inputList: [{
                name: '代理商orgId',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户编号',
                filed: 'app_mall_id',
                must: true,
              },
              {
                name: '门店编号',
                filed: 'app_secret',
                must: false,
              }
            ],

          },
          {
            payWay: '汇付斗拱',
            title: "汇付斗拱绑定参数",
            inputList: [{
                name: '服务商号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户编号',
                filed: 'app_mall_id',
                must: true,
              },
            ],

          },
          {
            payWay: '阿里云支付',
            title: "阿里云支付绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '门店编号',
                filed: 'app_mall_id',
                must: true,
              },
            ],

          },
          {
            payWay: '好码齐',
            title: "好码齐绑定参数",
            inputList: [{
                name: 'AppId',
                filed: 'app_id',
                must: true,
              },
              {
                name: 'AppSecret',
                filed: 'app_secret',
                must: true,
              },
              {
                name: '设备号',
                filed: 'app_mall_id',
                must: true,
              },
            ],

          },
          {
            payWay: '好哒支付',
            title: "好哒支付绑定参数",
            inputList: [{
                name: '商户编码',
                filed: 'app_id',
                must: true,
              },
              {
                name: '门店编号',
                filed: 'app_mall_id',
                must: true,
              },
            ],

          },
          {
            payWay: '星驿付',
            title: "星驿付绑定参数",
            inputList: [
              // {
              //   name: 'appid',
              //   filed: 'app_id',
              //   must: false,
              // },
              {
                name: '商户号',
                filed: 'app_mall_id',
                must: true,
              },
              // {
              //   name: '公钥',
              //   filed: 'pub_key',
              //   must: false,
              // },
            ],

          },
          {
            payWay: '东之付',
            title: "东之付绑定参数",
            inputList: [{
                name: '门店 ID',
                filed: 'app_mall_id',
                must: true,
              },
              {
                name: '东之付 AppId',
                filed: 'app_id',
                must: true,
              },
              {
                name: 'AppSecret',
                filed: 'app_secret',
                must: true,
              },
            ],

          },
          {
            payWay: '德宏农行付',
            title: "德宏农行付绑定参数",
            inputList: [{
                name: '商户号',
                filed: 'app_mall_id',
                must: true,
              },
              {
                name: '终端号',
                filed: 'app_id',
                must: true,
              },
              {
                name: 'AppSecret',
                filed: 'app_secret',
                must: true,
              },
            ],

          },

          {
            payWay: '陕西信合',
            title: "陕西信合绑定参数",
            inputList: [{
                name: '商户编号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '线下编号',
                filed: 'app_mall_id',
                must: false,
              },
            ],

          },
          {
            payWay: '收钱吧',
            title: "收钱吧绑定参数",
            inputList: [{
              name: '激活码',
              filed: 'app_id',
              must: true,
            }, {
              name: '终端号',
              filed: 'app_secret',
              must: true,
            }, ],

          },

          {
            payWay: '掌银支付',
            title: "掌银支付绑定参数",
            inputList: [{
                name: '应用编号',
                filed: 'prv_key',
                must: true,
              },
              {
                name: '商户号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户密钥',
                filed: 'app_secret',
                must: true,
              },
              {
                name: '门店号',
                filed: 'app_mall_id',
                must: true,
              },

            ],

          },
          {
            payWay: '云趣付',
            title: "云趣付绑定参数",
            inputList: [{
                name: '商户号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '商户密钥',
                filed: 'app_secret',
                must: true,
              },

            ],

          },
          {
            payWay: '乾收宝',
            title: "乾收宝绑定参数",
            inputList: [{
                name: '商户号',
                filed: 'app_id',
                must: true,
              },
              {
                name: '终端号',
                filed: 'app_mall_id',
                must: true,
              },

            ],

          },
          {
            payWay: '其他支付',
            title: "其他支付绑定参数",
            inputList: [{
                name: '支付名称',
                filed: 'app_id',
                must: true,
              },
              {
                name: '支付账号',
                filed: 'app_secret',
                must: false,
              },
              {
                name: '门店编号',
                filed: 'app_mall_id',
                must: false,
              },
              {
                name: '支付秘钥',
                filed: 'prv_key',
                must: false,
              },
            ],

          },
          // ex_info1：支付机构下服务商编码
          // ex_info2：三方支付机构商户编码：随行付39码
          // wx_sub_id：微信子商户号
          // ex_info3：微信公众号appid
          // ex_info4：微信小程序appld
          // ex_info5：支付公钥
          // ex_info6：支付私钥
        ],
        zh_type: 'offline',
        paymentInfo: {
          payOrgId: '',
          payOrgMchId: '',
          wxSubMchId: '',
          wxAppId: '',
          wxMinAppId: '',
          payWay: "", // 支付方式
          payWayChoose: false, // 支付宝使用官方支付（可实时到账）
          bossName: "", // 老板姓名
          bossPhone: "", // 老板电话
          payRemarks: "", // 备注
          fwsName: "", // 服务商名
          fwsPhone: "", // 服务商电话
          app_id: "",
          app_secret: "",
          app_mall_id: "",
          prv_key: "",
          pub_key: "",
        },
        mall_id: "", // 生成二维码时使用
        mall_name: "",
        shServerIp: "", // 商户服务器 IP
        mallInfo: {
          elabel_mch_id: "",
          elabel_mall_id: "10011001",
          sms_sign: '',
          mallId: "",
          mallName: "",
          sync_mall_id: '00010001',
          sfFaRadio: "按存储收费", //收费方案
          mallAnnualFee: "299",
          mdMoney: '299',
          expireTime: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
          zb_renew: false, // 是否总部续费
          force_pay_yn: 'N',
          pay_org_id: '',
          pay_mch_rate: '3.8',
          androidVer: Number(this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd')),
          winVer: Number(this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd')),
          forceUpdateYn: 'N'
        },
        // 软件版本下拉框的数据
        shEditionOptions: [{
            value: "零售5.0",
            label: "零售5.0",
          }, {
            value: "零售3.0",
            label: "零售3.0",
          },

          {
            value: "餐饮3.0",
            label: "餐饮3.0",
          },
        ],
        shUserTypeOptions: [{
            value: "免费用户",
            label: "免费用户",
          },
          {
            value: "标准用户",
            label: "标准用户",
          },
        ],
        shIndustryOptions: [{
            value: "饮品奶茶",
            label: "饮品奶茶",
          },
          {
            value: "中式餐厅",
            label: "中式餐厅",
          },
          {
            value: "西式餐厅",
            label: "西式餐厅",
          },
          {
            value: "火锅店",
            label: "火锅店",
          },
          {
            value: "果蔬生鲜",
            label: "果蔬生鲜",
          },
          {
            value: "便利店",
            label: "便利店",
          },
          {
            value: "小型超市",
            label: "小型超市",
          },
          {
            value: "休闲食品",
            label: "休闲食品",
          },
          {
            value: "烟酒糖茶",
            label: "烟酒糖茶",
          },
          {
            value: "母婴用品",
            label: "母婴用品",
          },
          {
            value: "化妆品",
            label: "化妆品",
          },
          {
            value: "饰品礼品",
            label: "饰品礼品",
          },
          {
            value: "家居家纺",
            label: "家居家纺",
          },
          {
            value: "保健食品",
            label: "保健食品",
          },
          {
            value: "办公用品",
            label: "办公用品",
          },
          {
            value: "体育用品",
            label: "体育用品",
          },
          {
            value: "服装鞋帽",
            label: "服装鞋帽",
          },
          {
            value: "皮具箱包",
            label: "皮具箱包",
          },
          {
            value: "家电数码",
            label: "家电数码",
          },
          {
            value: "户外用品",
            label: "户外用品",
          },
          {
            value: "汽车用品",
            label: "汽车用品",
          },
          {
            value: "农资用品",
            label: "农资用品",
          },
          {
            value: "农副用品",
            label: "农副用品",
          },
          {
            value: "宠物店",
            label: "宠物店",
          },
          {
            value: "其他",
            label: "其他",
          },
        ],
        payWayOptions: [
          // {
          //   label: "贝友PAY",
          //   value: "贝友PAY",
          // },
          // {
          //   label: "乐刷",
          //   value: "乐刷",
          // },

          {
            label: "尚米PAY",
            value: '尚米PAY',
          },
          {
            label: "好码齐",
            value: '好码齐',
          },
          {
            label: "嘉联支付",
            value: '嘉联支付',
          },
          {
            label: "银商支付",
            value: "银商支付",
          },
          {
            label: "拉卡拉",
            value: "拉卡拉",
          },
          {
            label: "京东支付",
            value: "京东支付",
          },
          {
            label: "河马付",
            value: "河马付",
          },
          {
            label: "信联付",
            value: "信联付",
          },
          {
            label: "平安银行",
            value: "平安银行",
          },
          {
            label: "中国银联",
            value: "中国银联",
          },
          {
            label: "创识农行",
            value: "创识农行",
          },
          {
            label: "通联支付",
            value: "通联支付",
          },

          // {
          //   label: "国铁吉讯",
          //   value: "国铁吉讯",
          // },

          {
            label: "微邮付",
            value: "微邮付",
          },
          {
            label: "付呗",
            value: "付呗",
          },
          {
            label: "随行付",
            value: "随行付",
          },
          {
            label: "汇付斗拱",
            value: "汇付斗拱",
          },
          {
            label: "阿里云支付",
            value: "阿里云支付",
          },
          {
            label: "好哒支付",
            value: "好哒支付",
          },
          {
            label: "星驿付",
            value: "星驿付",
          },
          {
            label: "东之付",
            value: "东之付",
          },
          {
            label: "德宏农行付",
            value: "德宏农行付",
          },

          {
            label: "陕西信合",
            value: "陕西信合",
          },
          {
            label: "收钱吧",
            value: "收钱吧",
          },
          {
            label: "掌银支付",
            value: "掌银支付",
          },
         {
           label: "云趣付",
           value: "云趣付",
         },
         {
            label: "乾收宝",
            value: "乾收宝",
          },
          {
            label: "其他支付",
            value: "其他支付",
          },
        ],
        // sortOptions: [
        //   {
        //     label: "注册时间降序",
        //     value: "注册时间降序",
        //   },
        //   {
        //     label: "最后登录降序",
        //     value: "最后登录降序",
        //   },
        //   {
        //     label: "商品数降序",
        //     value: "商品数降序",
        //   },
        //   {
        //     label: "门店数降序",
        //     value: "门店数降序",
        //   },
        //   {
        //     label: "支付账户降序",
        //     value: "支付账户降序",
        //   },
        //   {
        //     label: "注册时间升序",
        //     value: "注册时间升序",
        //   },
        //   {
        //     label: "最后登录升序",
        //     value: "最后登录升序",
        //   },
        //   {
        //     label: "商品数升序",
        //     value: "商品数升序",
        //   },
        //   {
        //     label: "门店数升序",
        //     value: "门店数升序",
        //   },
        //   {
        //     label: "支付账户升序",
        //     value: "支付账户升序",
        //   },
        // ],
        shMallAddressOptions: adr.adr,
        tableData: [],
        tableJson: [{
            // 循环渲染数据
            title: "来源",
            width: "90",
            sortType: "t_from",
          },
          {
            // 循环渲染数据
            title: "软件版本",
            width: "100",
            sortType: "soft_bb",
          },
          {
            // 循环渲染数据
            title: "版本号",
            width: "170",
            sortType: "soft_ver",
          },
          {
            title: "OEM",
            width: "80",
            sortType: "oem_yn",
          },
          {
            title: "手机号",
            width: "120",
            sortType: "user_phone",
          },
          {
            title: "联系人名",
            width: "110",
            sortType: "user_name",
          },
          {
            title: "门店名称",
            width: "170",
            sortType: "mall_name",
          },
          {
            title: "门店数",
            width: "90",
            sortType: "mall_count",
          },
          // {
          //    title: "加盟门店数",
          //    width: "120",
          //    sortType: "jm_mall_num",
          //  },
          {
            title: "可用加盟门店数",
            width: "140",
            sortType: "jm_mall_can_use_num",
          },
          {
            title: "所属行业",
            width: "100",
            sortType: "bus_type",
          },
          {
            title: "商品数",
            width: "90",
            sortType: "pro_count",
          },
          {
            title: "上日进货",
            width: "100",
            sortType: "pre_day_in_money",
          },
          {
            title: "上日批发",
            width: "100",
            sortType: "pre_day_pf_money",
          },
          {
            title: "上日零售",
            width: "100",
            sortType: "pre_day_pos_money",
          },
          {
            title: "近30天进货",
            width: "120",
            sortType: "pre_30day_in_money",
          },
          {
            title: "近30天批发",
            width: "120",
            sortType: "pre_30day_pf_money",
          },
          {
            title: "近30天零售",
            width: "120",
            sortType: "pre_30day_pos_money",
          },
          {
            title: "上日扫码",
            width: "100",
            sortType: "pre_day_scan_money",
          },
          {
            title: "近30天扫码",
            width: "120",
            sortType: "pre_30day_scan_money",
          },
          {
            title: "年费",
            width: "80",
            sortType: "nf_money",
          },
          {
            title: "注册时间",
            width: "180",
            sortType: "creat_time",
          },
          {
            title: "最后登录时间",
            width: "180",
            sortType: "last_login_time",
          },
          {
            title: "最后登录设备",
            width: "200",
            sortType: "last_login_device",
          },
          {
            title: "支付账户",
            width: "170",
            sortType: "online_zh_name",
          },
          {
            title: "省",
            width: "90",
            sortType: "shen",
          },
          {
            title: "市",
            width: "90",
            sortType: "shi",
          },
          {
            title: "区",
            width: "90",
            sortType: "qu",
          },
          {
            title: "门店地址",
            width: "300",
            sortType: "address",
          },
          {
            title: "备注",
            width: "200",
            sortType: "bz_memo",
          },
          {
            title: "开户人",
            width: "130",
            sortType: "partner_name",
          },
          {
            title: "代理商",
            width: "140",
            sortType: "comp_name",
          },
          {
            title: "代理商手机号",
            width: "120",
            sortType: "partner_phone",
          },
          {
            title: "代理商地址",
            width: "280",
            sortType: "comp_address",
          },
          {
            title: "上级",
            width: "130",
            sortType: "p_partner_name",
          },
          {
            title: "上级公司",
            width: "200",
            sortType: "p_comp_name",
          },
        ],
        mallData: [],
        payWayData: [], // 支付配置 中 已经配置过的支付方式
        addr: [],
        QRCodeEnlargeDialog: false, // 二维码放大弹框
        selfRegDialog: false, // 自主注册二维码放大
        cancelAllDataDialog: false, // 清除所有数据
        cancelDataTypeIdx: "1", // 要删除的数据类型
        partnerPwd: "", // 商户的登录密码  用于清除所有的数据
        cancelDataTime: [new Date(), new Date()], // 清楚数据是选择的时间段
        pickerOptions: {
          // 选择时间是的快捷方式
          shortcuts: [{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        mchTotalPop: false,
        mchTotalInfo: {},
        //门店续费
        mallXfData: [],
        //日志推送版本
        logOption: [{
          val: 'winPc',
        }, {
          val: 'androidPad',
        }, ],
        logSet: {
          logVer: 'winPc',
          logMallId: '',
        },
        logGet: {
          logVer: '',
          logDate: this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd'),
          logMallId: '',
        },
        custom: {
          custom_yn: 'N',
          custom_name: '',
          custom_url: '',
          custom_ex: '',
        },
        downLoadUrl: '',

        showMorePop: false,
        autoSetMchId: '',
        autoJson: [],
        autoJsonInfo: {
          soft_name: '',
          soft_ver: '',
          down_url: '',
          enable_yn: 'N'
        },
        showTime: true,
        /* 布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
        sendTime: '',
        /* 倒计时 计数器 */
        timer: null,
        clearYzm: '',
        clearReqId: '',
      };
    },
    async created() {


      if (this.bykApi.smCom.fSmIsEmpty(this.bykApi.global.fGetPlatform().partnerInfo.data.pay_info)) {
        this.payWayOptions = [{
          label: "尚米PAY",
          value: "尚米PAY",
        }, ]
      } else {
        let payArr = JSON.parse(this.bykApi.global.fGetPlatform().partnerInfo.data.pay_info);
        let result = this.payWayOptions.filter(item => payArr.includes(item.label));
        // this.payWayOptions = result
        let arr = []
        this.payMentList.forEach(item => {
          result.forEach((sitem) => {
            if (item.payWay == sitem.value) {
              arr.push(item)
            }
          })

        })
        this.payMentList = arr

      }
      this.showQcSj = await this.bykApi.global.fGetSmMenuQx('清除所有数据')
      this.showKhdBbTs = await this.bykApi.global.fGetSmMenuQx('客户端版本推送')
      this.showJmmd = await this.bykApi.global.fGetSmMenuQx('加盟门店')
      this.showZywz = await this.bykApi.global.fGetSmMenuQx('主页网址')
      this.showKyjmd = await this.bykApi.global.fGetSmMenuQx('可用加盟门店')
      this.showXxtztx = await this.bykApi.global.fGetSmMenuQx('消息通知提醒')
      this.showFpgg = await this.bykApi.global.fGetSmMenuQx('副屏广告')
      this.showZdmk = await this.bykApi.global.fGetSmMenuQx('自定模块')









      this.init();
    },
    watch: {
      timeRadio() {
        this.init();
      },
      dzjqRadio() {
        this.fGetDzjqList(1)
      },
      ydyjRadio() {
        this.fGetYdyjList(1)
      },
      ydyjSbsqPop(newVal) {
        if (newVal) {
          let json = {
            appType: 'smSell',
            mchUrl: `http://${this.shServerIp}/smSellAdmin/adminApi`,
            mchId: this.mallDisposeInfo.user_phone
          }
          // let sReqJsonBase64 = Base64.encode(sReqJsonStr);
          this.ydyjSbsqUrl =
            `https://mobile.poscom.cn/frontmanage/openoauth/authorize?code=3DC67B5F32A9304AA461B605BF5EFF6C&state=${JSON.stringify(json)}`
          setTimeout(() => {
            document.getElementById("qrcodeMax1").innerHTML = "";
            var qrcode = new this.QRCode(this.$refs.qrCodeUrlMax1, {
              // text: `https://openauth.alipay.com/oauth2/appToAppAuth.htm?app_id=2021002147672969&redirect_uri=http%3A%2F%2Fwww.91byk.com%2FbyPay%2FbyPayAliAuth.html&shPhone=${this.mallDisposeInfo.user_phone}&shMallId=${this.mall_id}&compName=BYK&zhName=${zhName}&tFrom=bykSell`, // 需要转换为二维码的内容
              text: this.ydyjSbsqUrl,
              // text: "http://www.baidu.com",
              width: 200,
              height: 200,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: 3,
            });
          }, 200)

        }
      }


    },
    methods: {
      fCreatedAkSk(type) {
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shPhone)) {
          return this.$message("手机号码不能为空");
        }
        if (type == 'org_ak') {
          this.shInfo.org_ak = md5('smSoft_' + this.shInfo.shPhone + '_smSell')
          console.log(md5('smSoft_' + this.shInfo.shPhone + '_smSell'))
        }
        if (type == 'org_sk') {
          this.shInfo.org_sk = md5('smSell_' + this.shInfo.shPhone + '_smSoft')
        }
      },
      async init(nowPage) {
        // console.log(this.radio, this.shen, this.shi, this.qu);
        // if (
        // this.radio == "区域查询" &&
        //   this.bykApi.smCom.fSmIsEmpty(this.shen) &&
        //   this.bykApi.smCom.fSmIsEmpty(this.shi) &&
        //   this.bykApi.smCom.fSmIsEmpty(this.qu)
        // ) {
        //   return this.$message("请选择区域");
        // }
        // this.shInfo.shHomeUrl =
        //   this.bykApi.global.fGetPlatform().partnerInfo.data.main_url;
        // this.shShopMallExpice = "2021-2-22";
        // console.log(res);

        let res = await this.fBykGetShInfo();

        // console.log(res);
        if (res.result == "sucess") {
          this.tableData = res.data;
          this.TR = 0
          this.TP = 0
          if (res.data.length > 0) {
            this.TR = res.data[0].TR;
            this.TP = res.data[0].TP;
          }
        } else {
          return this.$message(res.msg);
        }
      },
      //表格导出
      fExportDataEvent() {
        this.$refs.xTable1.exportData({
          type: 'csv'
        })
      },
      fBuyChoose(type) {
        this.buyType = type;
      },
      fGoBuy(price) {
        this.buySoftwareMoney = price;
        this.goBuyDialog = !this.goBuyDialog;
        // this.buySuccess = !this.buySuccess;
        // this.buyFail = !this.buyFail;
        setTimeout(() => {
          this.buySoftware = !this.buySoftware;
        }, 0);
      },

      // 注册商户
      fRegMerchant() {
        // if (Number(this.bykApi.global.fGetPlatform().partnerInfo.data.can_reg_user_num) <= 0) {
        //   this.fSelfReg()
        //   return
        // }
        this.addMerchant = !this.addMerchant;
        this.merchantAddOrEdit = "ADD";
        this.shInfo.shHomeUrl =
          this.bykApi.global.fGetPlatform().partnerInfo.data.main_url;
        this.shInfo.shAllCost =
          Number(
            this.bykApi.global.fGetPlatform().partnerInfo.data.partner_base_price
          ) < 36.5 ?
          "36.5" :
          this.bykApi.global.fGetPlatform().partnerInfo.data
          .partner_base_price;
      },
      // 软件版本 change 事件
      shEditionChange(val) {

        this.shInfo.shEdition = val[0];
      },
      // 用户类型 change 事件
      shUserTypeChange(val) {
        this.shInfo.shUserType = val[0];
      },
      // 所属行业 change 事件
      shIndustryChange(val) {
        this.shInfo.shIndustry = val[0];
      },
      // 门店地址 change 事件
      shMallAddressChange(e) {
        this.addr = JSON.parse(JSON.stringify(e));

        // this.shInfo.shMallAddress = e[0] + "-" + e[1] + "-" + e[2];
        // console.log(e, this.shInfo.shMallAddress);
      },

      fHeadAddressChange(e) {
        this.shen = e[0];
        this.shi = e[1];
        this.qu = e[2];
        this.searchAddressVal = e[0] + "-" + e[1] + "-" + e[2];
        this.merInputVal = "";
      },
      fHeadTypeChange(e) {
        this.searchTypeVal = e[0];
      },

      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fHeadRadioChange() {
        this.searchAddressVal = "";
        this.merInputVal = "";
        this.init();
      },
      // 自主注册
      fSelfReg() {
        this.selfRegDialog = true;
        this.fSelfQrCreate()
      },

      // 新增商户
      async fAddMerchant() {
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shEdition)) {
          return this.$message("软件版本不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shPhone)) {
          return this.$message("手机号码不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shLxName)) {
          return this.$message("联系人名不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shUserType)) {
          return this.$message("用户类型不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shMallName)) {
          return this.$message("门店名称不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shIndustry)) {
          return this.$message("所属行业不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shMainMarketing)) {
          return this.$message("主要经营不能为空");
        }

        if (this.addr.length == 0) {
          return this.$message("门店地址不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shMallDetailAddress)) {
          return this.$message("门店详细地址不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shHomeUrl)) {
          return this.$message("主页网址不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.jm_mall_can_use_num)) {
          return this.$message("可用加盟门店不能为空");
        }

        if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shCanUseComputed)) {
          return this.$message("可用电脑不能为空");
        }
        console.log(this.shInfo.shShopMallExpice)
        // if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shShopMallExpice)) {
        //   return this.$message("商城到期不能为空");
        // }
        // if (this.bykApi.smCom.fSmIsEmpty(this.shInfo.shOrderGoodsExpice)) {
        //   return this.$message("订货到期不能为空");
        // }
        let res = await this.fBykSellShReg();
        if (res.result == "sucess") {
          this.addMerchant = false;
          this.$alert("默认工号：1001,密码手机后四位", "开户成功", {
            confirmButtonText: "确定",
            callback: () => {
              this.init();
            },
          });
          return;
        }
        return this.$message(res.msg);
      },
      // 保存商户
      async fSaveMerchant() {
        // if(this.shInfo.shEdition == '零售5.0'){
        let resUpdate = await this.fExecSqlFile()
        if (resUpdate.result != "sucess") {
          this.$message(resUpdate.msg);
        }
        // }
        let res = await this.fBykSellShEdit();
        // console.log(res);
        if (res.result == "sucess") {
          this.init();
          this.fClose();
          this.$message(res.msg);
          return;
        }
        // this.addMerchant = false;
        return this.$message(res.msg);
        // console.log(this.shInfo);
      },
      // 关闭
      fClose() {
        this.addMerchant = false;
        this.addr = [];
        this.shInfo = Object.assign({}, {
          mchSrvIp: this.bykApi.global.fGetPlatform().partnerInfo.data.fwq_ip,
          partnerPhone: this.bykApi.global.fGetPlatform().partnerInfo.phone,
          shEdition: "零售5.0", // 软件版本
          shPhone: "", // 手机号码
          shLxName: "", // 联系人名
          shUserType: "标准用户", // 用户类型
          shMallName: "", // 门店名称
          shIndustry: "便利店", // 所属行业
          shMainMarketing: "", // 主要经营
          // shMallAddress: "", // 门店地址
          shMallDetailAddress: "", // 门店详细地址
          shRemarks: "", // 备注信息
          shHomeUrl: "", // 主页网址
          jm_mall_can_use_num: '0',
          shAdUrl: "", // 广告网址
          shAdChoose: false, // 副屏广告统一管理是否选中
          wsYn: false,
          shCustomModelName: "", // 自定模块名
          shCustomModelUrl: "", // 自定网址
          shCustomModelChoose: false, // 自定模块打开独立浏览
          shAllCost: "299", // 全部费用
          mustPayCount: '3',
          shCanUseComputed: "3", // 可用电脑
          shShopMallExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 商城到期
          shOrderGoodsExpice: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ), // 订货到期
          org_ak: '',
          org_sk: '',
        });
      },

      // 排序
      async fHeadSort(type, asc_desc = "") {
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        let res = await this.fBykGetShInfo();
        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      // 配置门店的内层弹框
      fInnerClose() {
        this.innerModifyMall = false;
        Object.assign(this.mallInfo, {
          sfFaRadio: "按存储收费", //收费方案
          mallId: "",
          sms_sign: '',
          elabel_mch_id: '',
          elabel_mall_id: '10011001',
          mallName: "",
          sync_mall_id: '00010001',
          mallAnnualFee: "299",
          // mdMoney:'299',
          expireTime: new Date(
            new Date().getTime() + 30 * 24 * 60 * 60 * 1000
          ),
          zb_renew: "N",
          force_pay_yn: "N",
          pay_org_id: '',
          pay_mch_rate: '3.8',
        });
      },

      // 表头点击事件
      fTablePhoneClick(e) {

      },

      // 每个商户的修改按钮
      async fModify(row) {
        this.merchantAddOrEdit = "EDIT";
        let res = await this.fBykGetShId(row);

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.shServerIp = row.user_ip
        this.shServerUrl = row.load_url
        this.shInfo.shPhone = res.data[0].user_phone;

        this.addMerchant = !this.addMerchant;
        this.shInfo.mchSrvIp = res.fy_info[0].user_ip;
        this.shInfo.shEdition = res.data[0].soft_bb;
        this.shInfo.partnerPhone = res.data[0].partner_phone;
        this.shInfo.shLxName = res.data[0].user_name;
        this.shInfo.shUserType = res.data[0].user_type;
        this.shInfo.shMallName = res.data[0].mall_name;
        this.shInfo.shIndustry = res.data[0].bus_type;
        this.shInfo.shMainMarketing = res.data[0].bus_memo;
        this.addr = [res.data[0].shen, res.data[0].shi, res.data[0].qu];
        this.shInfo.shMallDetailAddress = res.data[0].address;
        this.shInfo.shRemarks = res.fy_info[0].bz_memo;
        this.shInfo.shHomeUrl = res.data[0].main_url;

        this.shInfo.shAdUrl = res.data[0].gg_url;
        this.shInfo.shAdChoose = res.data[0].gg_ty_yn == "Y" ? true : false;
        this.shInfo.wsYn = res.data[0].ws_yn == "Y" ? true : false;
        this.shInfo.shCustomModelName = res.data[0].shop_name;
        this.shInfo.shCustomModelUrl = res.data[0].shop_url;
        this.shInfo.shCustomModelChoose =
          res.data[0].shop_url_to_yn == "Y" ? true : false;
        this.shInfo.shAllCost = res.fy_info[0].nf_money;
        this.shInfo.jm_mall_can_use_num = res.fy_info[0].jm_mall_can_use_num;
        this.shInfo.mustPayCount = res.data[0].must_pay_count
        this.shInfo.shCanUseComputed = res.data[0].pc_can_use_num;
        this.shInfo.org_ak = res.data[0].org_ak;
        this.shInfo.org_sk = res.data[0].org_sk;
        this.shInfo.shShopMallExpice = new Date(
          res.fy_info[0].sc_stop_time.split(" ")[0]
        );
        this.shInfo.shOrderGoodsExpice = new Date(
          res.fy_info[0].dh_stop_time.split(" ")[0]
        );


      },
      //删除商户
      async fDelMch() {
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fDelMchInfo(this.shInfo.shPhone);
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.init();
          this.fClose();
          this.$message(res.msg);
        }).catch(() => {});
      },
      // 每个商户的配置门店按钮
      async fDisposeMall(row) {
        // console.log(row);
        this.shServerIp = row.user_ip;
        this.shServerUrl = row.load_url;
        this.jkMchId = row.user_phone;

        this.mallDisposeInfo = row;
        let res = await this.fBykShMallInfo();
        console.log(res)
        if (res.result == "sucess") {
          this.mallData = res.data;
          this.mallInfo.mdMoney = res.reg_info[0].sell_md_money
          this.mallInfo.androidVer = Number(res.reg_info_sub.andriod_ver)
          this.mallInfo.winVer = Number(res.reg_info_sub.win_ver)
          this.mallInfo.forceUpdateYn = res.reg_info_sub.force_update_yn
          this.mallDispose = !this.mallDispose;
          this.downLoadUrl = ''
          this.custom = {
            custom_yn: 'N',
            custom_name: '',
            custom_url: '',
            custom_ex: '',
          }
          this.logSet = {
            logVer: 'winPc',
            logMallId: '',
          }
          this.logGet = {
            logVer: '',
            logDate: this.bykApi.timeHelper.manyDaysAgo(0, 3, 'yyyyMMdd'),
            logMallId: '',
          }
          let resEx = await this.fMchRegEx({
            oper: 'GET'
          })
          if (resEx.result != "sucess") {
            return
          }
          this.custom = resEx.data
          if (this.bykApi.smCom.fSmIsEmpty(resEx.data.debug_mall_list)) {
            return
          }
          let debugMallList = JSON.parse(resEx.data.debug_mall_list)
          console.log(debugMallList)
          this.logSet.logMallId = debugMallList[this.logSet.logVer]
          // this.logSet:{
          //  logVer:'',
          //  logMallId:'',
          // },
          return;
        }
        console.log(this.mallInfo.mdMoney, 123)
        return this.$message(res.msg);
        // console.log(res);
      },
      fChgZhType(type) {
        this.zh_type = type
        this.paymentBindingToggle(type)
        console.log(type)
      },
      // 每个商户的支付配置按钮
      async fPaymentDispose(row) {
        this.mall_id = row.mall_id;
        let res = await this.fBykShPayInfo(row);
        // console.log(res);
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.payWayData = res.data;
        if (row.oper == 'save') {
          return
        }
        let defaultPayway = res.data.find((item) => {
          // return item.zh_type == "线下";
          return item.mr_mark == "是";
        });
        if (defaultPayway) {
          this.paymentInfo.payWay = defaultPayway.zh_name;
        }

        this.paymentBindingToggle('线下');
        // console.log("row", row);
        this.paymentDispose = !this.paymentDispose;
      },

      // 支付配置弹框的点击保存
      async fPaymentDisposeSave() {
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bossName)) {
          return this.$message("老板姓名不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bossPhone)) {
          return this.$message("老板电话不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fwsName)) {
          return this.$message("服务商名不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.fwsPhone)) {
          return this.$message("联系电话不能为空");
        }
        if (this.paymentInfo.payWay == "贝友PAY") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bykPaySecretKey)) {
            return this.$message("支付密匙不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.bykMallId)) {
            return this.$message("门店编码不能为空");
          }
        }
        if (this.paymentInfo.payWay == "嘉联支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("机构编码不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("商户编码不能为空");
          }
        }

        if (this.paymentInfo.payWay == "尚米PAY") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店编码不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            this.paymentInfo.app_secret = '1'
          }
        }
        if (this.paymentInfo.payWay == "中国银联") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("支付密匙不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("终端号不能为空");
          }
        }
        if (this.paymentInfo.payWay == "创识农行") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("商户编号不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.prv_key)) {
            return this.$message("支付秘钥不能为空");
          }

        }
        if (this.paymentInfo.payWay == "通联支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("appid不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("商不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.prv_key)) {
            return this.$message("支付秘钥不能为空");
          }

        }

        // if (this.paymentInfo.payWay == "国铁吉讯") {
        //   if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
        //     return this.$message("app_id不能为空");
        //   }
        //   if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
        //     return this.$message("app_secret不能为空");
        //   }

        // }

        if (this.paymentInfo.payWay == "平安银行") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("注册号不能为空");
          }
        }
        if (this.paymentInfo.payWay == "微邮付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("支付密匙不能为空");
          }
        }
        if (this.paymentInfo.payWay == "乐刷") {}
        if (this.paymentInfo.payWay == "付呗") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店ID不能为空");
          }

          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("AppSecret不能为空");
          }
        }
        if (this.paymentInfo.payWay == "随行付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("商户编号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "汇付斗拱") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("商户编号 不能为空");
          }
        }

        if (this.paymentInfo.payWay == "阿里云支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店编号 不能为空");
          }

        }
        if (this.paymentInfo.payWay == "好码齐") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("AppId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("AppSecret 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("设备号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "好哒支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店编号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "星驿付") {

          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("商户号不能为空");
          }
        }
        if (this.paymentInfo.payWay == "东之付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店ID不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("AppSecret不能为空");
          }
        }
        if (this.paymentInfo.payWay == "德宏农行付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("商户号AppMallId不能为空");
          }

          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("AppSecret不能为空");
          }
        }
        if (this.paymentInfo.payWay == "陕西信合") {}
        if (this.paymentInfo.payWay == "收钱吧") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("商户CODE 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "银商支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("appid 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("商户号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("终端号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "拉卡拉") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("appid 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("终端号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("商户号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "京东支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("店铺编号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("代理秘钥 不能为空");
          }

        }
        //河马付
        if (this.paymentInfo.payWay == "河马付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("appId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("subAppId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("storeNo 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "信联付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("appId 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("AppSercet 不能为空");
          }
        }


        if (this.paymentInfo.payWay == "掌银支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.prv_key)) {
            return this.$message("应用编号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("商户号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("商户密钥 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店号 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "云趣付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("商户号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("商户密钥 不能为空");
          }
        }
        if (this.paymentInfo.payWay == "乾收宝") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_id)) {
            return this.$message("商户号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("终端号 不能为空");
          }
        }

        if (this.paymentInfo.payWay == "其他支付") {
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_secret)) {
            return this.$message("支付账号 不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.paymentInfo.app_mall_id)) {
            return this.$message("门店编号 不能为空");
          }
        }


        let res = await this.fBykSellBandPay();
        this.fPaymentDispose({
          mall_id: this.mall_id,
          oper: 'save'
        })
        // if (res.result == "sucess") {
        // this.paymentDispose = false;
        // }
        return this.$message(res.msg + (this.bykApi.smCom.fSmIsEmpty(res.data) ? '' : "：" + res.data));
      },
      // 支付配置弹框的点击关闭
      fPaymentDisposeClose() {
        this.reductionData();
        this.paymentInfo.payWay = "贝友PAY";
        this.paymentDispose = false;
      },
      // 支付配置 支付方式的 change 事件
      fPayWayChange(e, type) {
        this.paymentInfo.payWay = e[0];
        this.reductionData();
        this.paymentBindingToggle('', 'chg');
        if (type == 'chg') {
          return
        }
        // 进行数据值的还原
        this.paymentDisposeOpened();
      },
      // 支付方式切换时 触发重新赋值
      paymentBindingToggle(zh_type, oper) {
        let payWay = this.paymentInfo.payWay;
        // 查找 返回的数据是否包含要查找的值
        let obj = {};
        obj = this.payMentList.find((item) => {
          return item.payWay === payWay; //筛选出匹配数据
        });
        console.log(obj,'paymentBindingToggle')
        this.actPayWay = obj || {}
        console.log(this.actPayWay,'actPayWay')
        if (oper == 'chg') {
          return
        }
        let res
        if (zh_type) {
          res = this.payWayData.find((item) => {
            return item.zh_type == this.zh_type;
          });
        } else {
          res = this.payWayData.find((item) => {
            return item.zh_name == payWay
          });
        }

        this.payShowMore = false
        console.log(res)
        if (!res) {
          this.reductionData()
          if (payWay == "尚米PAY") {
            this.paymentInfo.smMallId = '10001';
          }

          return;
        }
        if (zh_type) {
          this.fPayWayChange([res.zh_name])
        }
        this.paymentInfo.payWayChoose = res.alipay_gfyn == "Y" ? true : false;
        this.paymentInfo.bossName = res.zh_user_name;
        this.paymentInfo.bossPhone = res.zh_user_phone;
        this.paymentInfo.payRemarks = res.user_memo;
        this.paymentInfo.fwsName = res.chg_person;
        this.paymentInfo.fwsPhone = res.chg_person_phone;
        this.zh_type = res.zh_type;



        this.paymentInfo.payOrgId = res.ex_info1;
        this.paymentInfo.payOrgMchId = res.ex_info2;
        this.paymentInfo.wxSubMchId = res.wx_sub_id;
        this.paymentInfo.wxAppId = res.ex_info3;
        this.paymentInfo.wxMinAppId = res.ex_info4;


        if (this.paymentInfo.payOrgId ||
          this.paymentInfo.payOrgMchId ||
          this.paymentInfo.wxSubMchId ||
          this.paymentInfo.wxAppId ||
          this.paymentInfo.wxMinAppId) {
          this.payShowMore = true
        }
        this.paymentInfo.app_id = ''
        this.paymentInfo.app_secret = ''
        this.paymentInfo.app_mall_id = ''

        this.paymentInfo.app_id = res.app_id;
        this.paymentInfo.app_secret = res.app_secret;
        this.paymentInfo.app_mall_id = res.app_mall_id;
        // if (payWay == "创识农行"  || payWay == "通联支付" || payWay == "其他支付") {
        this.paymentInfo.prv_key = res.ex_info6;
        this.paymentInfo.pub_key = res.ex_info5;
        // }

      },
      // 数据还原
      reductionData() {
        this.paymentInfo = Object.assign(this.paymentInfo, {
          payWayChoose: false, // 支付宝使用官方支付（可实时到账）
          payOrgId: "",
          payOrgMchId: "",
          wxSubMchId: "",
          wxAppId: "",
          wxMinAppId: "",
          bossName: "", // 老板姓名
          bossPhone: "", // 老板电话
          payRemarks: "", // 备注
          app_id: "",
          app_secret: "",
          app_mall_id: "",
          prv_key: "",
        });
      },

      // 重置门店信息
      async fResetMall() {
        this.$confirm(
          "此操作将 1001 密码重置为手机后四位，确认重置？",
          "重置密码", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(async () => {
          let res = await this.fBykSellResetPwd();
          return this.$message(res.msg);
        });
      },

      // 清除所有数据
      async fResetAllData() {
        if (this.bykApi.global.fGetPlatform().partnerInfo.phone != '18957102098') {
          let res1 = await this.SRV_SEND_SMS({
            oper: 'CHK_SMS_YZM'
          })
          if (res1.result != 'sucess') {
            return this.$message(res1.msg);
          }
          this.partnerPwd = res1.partner_pwd;
        }

        let oper = "";
        let time1 = "";
        let time2 = "";

        if (this.cancelDataTypeIdx == "1") {
          oper = "YW_DATA";
        } else if (this.cancelDataTypeIdx == "2") {
          oper = "ALL_YW_DATA";
        } else if (this.cancelDataTypeIdx == "3") {
          oper = "ALL";
        }
        time1 =
          this.cancelDataTime[0].getFullYear() +
          "-" +
          (Number(this.cancelDataTime[0].getMonth()) + 1) +
          "-" +
          this.cancelDataTime[0].getDate();
        time2 =
          this.cancelDataTime[1].getFullYear() +
          "-" +
          (Number(this.cancelDataTime[1].getMonth()) + 1) +
          "-" +
          this.cancelDataTime[1].getDate();
        if (this.bykApi.smCom.fSmIsEmpty(oper)) {
          return this.$message("请选择要删除的业务类型");
        }
        // if (this.bykApi.smCom.fSmIsEmpty(this.partnerPwd)) {
        //   return this.$message("请输入合作伙伴密码");
        // }
        let loadingInstance = Loading.service({
          lock: true,
          text: '加载中……',
          background: 'rgba(0, 0, 0, 0)'
        })
        let res = await this.fBykSellClearData(oper, time1, time2);
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message("清除数据成功");
        this.cancelAllDataDialog = false;
      },

      // 退出
      fColseMall() {
        this.mallDispose = false;
      },
      // 修改或增加门店
      fModifyOrAddMall(row, type) {
        //判断权限
        this.modifyOrAddMallType = type;
        if (type == "modify") this.innerModifyMallTitle = "门店信息 > 修改门店";
        if (type == "add") this.innerModifyMallTitle = "门店信息 > 增加门店";

        // console.log(row);
        if (type == "modify") {
          this.mallInfo.mallId = row.mall_id;
          this.mallInfo.mallName = row.mall_name;
          this.mallInfo.mallAnnualFee = row.fy_money;
          this.mallInfo.sms_sign = row.sms_sign;
          this.mallInfo.elabel_mch_id = row.elabel_mch_id;
          this.mallInfo.elabel_mall_id = row.elabel_mall_id || '10011001';


          // this.mallInfo.mdMoney = row.md_money;
          this.mallInfo.expireTime = new Date(row.stop_time);
          this.mallInfo.zb_renew = row.zb_xf_yn == "Y" ? true : false;

          this.mallInfo.force_pay_yn = row.force_pay_yn;
          this.mallInfo.pay_org_id = row.pay_org_id;
          this.mallInfo.pay_mch_rate = row.pay_mch_rate;
          // this.mallInfo.androidVer = Number(this.bykApi.timeHelper.manyDaysAgo(0, 3,'yyyyMMdd'))
          // this.mallInfo.winVer = Number(this.bykApi.timeHelper.manyDaysAgo(0, 3,'yyyyMMdd'))
          console.log(this.mallInfo.winVer)
        }
        if (type == 'add' && this.bykApi.global.fGetPlatform().partnerInfo.data.can_add_mall != 'Y') {
          return this.$message("暂无新增门店的权限");
        }
        this.innerModifyMall = !this.innerModifyMall;
      },

      // 内层弹框的  增加门店
      async fAddMall() {
        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.mallName)) {
          return this.$message("门店名称不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.mallAnnualFee)) {
          return this.$message("门店年费不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.mdMoney)) {
          return this.$message("终身费用不能为空");
        }

        if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.expireTime)) {}
        if (this.mallInfo.force_pay_yn == 'Y') {
          if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.pay_org_id)) {
            return this.$message("请输入支付服务商");
          }
        }
        // 增加接口
        let res = await this.fBykSellAddMall();
        if (res.result == "sucess") {
          // this.innerModifyMall = false;
          this.fInnerClose();
          // 获取接口
          let res = await this.fBykShMallInfo();
          if (res.result == "sucess") {
            this.mallData = res.data;
            this.mallInfo.mdMoney = res.reg_info[0].sell_md_money
            // this.mallDispose = !this.mallDispose;
            this.init();
            return;
          }
        }
        return this.$message(res.msg);
      },

      // 内层弹框的  修改门店
      async fEditMall(type) {

        if (type == 'DJ') {
          this.$confirm('是否确认冻结', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirmButton',
          }).then(async () => {
            let time = new Date()
            let res = await this.fBykSellEditMall(time);
            if (res.result == "sucess") {
              // this.innerModifyMall = false;
              this.fInnerClose();
              this.init();
              let res = await this.fBykShMallInfo();
              if (res.result != "sucess") {
                return this.$message(res.msg);
              }
              this.mallData = res.data;
              this.mallInfo.mdMoney = res.reg_info[0].sell_md_money

            }
            return this.$message(res.msg);

          }).catch(() => {});
          return
        }
        if (this.mallInfo.force_pay_yn == 'Y') {
          if (this.bykApi.smCom.fSmIsEmpty(this.mallInfo.pay_org_id)) {
            return this.$message("请输入支付服务商");
          }
        }
        let res = await this.fBykSellEditMall();
        if (res.result == "sucess") {
          // this.innerModifyMall = false;
          this.fInnerClose();
          this.init();
          let res = await this.fBykShMallInfo();
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.mallData = res.data;
          this.mallInfo.mdMoney = res.reg_info[0].sell_md_money

        }
        return this.$message(res.msg);
      },

      // 分页
      async fCurrentChange(e) {
        this.nowPage = e;
        let res = await this.fBykGetShInfo();
        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      async fSizeChange(e) {
        this.nowPage = 1;
        this.pageSize = e;
        let res = await this.fBykGetShInfo();
        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },
      // 支付配置弹框弹出后进行二维码的生成
      paymentDisposeOpened() {
        // document.getElementById("qrcode").innerHTML = "";
        // this.creatQrCode();
      },

      // 生成 二维码
      creatQrCode() {
        let payWay = this.paymentInfo.payWay;
        let zhName = null;
        if (payWay == "贝友PAY") {
          zhName = "BYP";
        }
        if (payWay == "尚米PAY") {
          zhName = "SMP";
        }
        if (payWay == "中国银联") {
          zhName = "ZGYL";
        }
        if (payWay == "创识农行") {
          zhName = "CSNH";
        }
        // if (payWay == "国铁吉讯") {
        //   zhName = "GTJX";
        // }

        if (payWay == "平安银行") {
          zhName = "PAYH";
        }
        if (payWay == "微邮付") {
          zhName = "WYF";
        }
        if (payWay == "乐刷") {
          zhName = "LS";
        }
        if (payWay == "付呗") {
          zhName = "FB";
        }
        if (payWay == "随行付") {
          zhName = "SXF";
        }
        if (payWay == "好哒支付") {
          zhName = "HDZF";
        }
        if (payWay == "星驿付") {
          zhName = "XYF";
        }
        if (payWay == "东之付") {
          zhName = "LBN";
        }
        if (payWay == "德宏农行付") {
          zhName = "HDNHF";
        }
        if (payWay == "陕西信合") {
          zhName = "SXXH";
        }
        if (payWay == "收钱吧") {
          zhName = "SQB";
        }
        if (payWay == "阿里云支付") {
          zhName = "ALYZF";
        }
        if (payWay == "好码齐") {
          zhName = "HMQ";
        }
        if (payWay == "京东支付") {
          zhName = "JDZF";
        }
        if (payWay == "汇付斗拱") {
          zhName = "HFDG";
        }

        if (payWay == "河马付") {
          zhName = "HMF";
        }
        if (payWay == "信联付") {
          zhName = "XLF";
        }
        if (payWay == "银商支付") {
          zhName = "YSYH";
        }
        if (payWay == "拉卡拉") {
          zhName = "LKL";
        }
        if (payWay == "掌银支付") {
          zhName = "ZYZF";
        }
        if (payWay == "云趣付") {
          zhName = "YQF";
        }
        if (payWay == "乾收宝") {
          zhName = "QSB";
        }


        var qrcode = new this.QRCode(this.$refs.qrCodeUrlMax, {
          text: `https://openauth.alipay.com/oauth2/appToAppAuth.htm?app_id=2021002147672969&redirect_uri=http%3A%2F%2Fwww.91byk.com%2FbyPay%2FbyPayAliAuth.html&shPhone=${this.mallDisposeInfo.user_phone}&shMallId=${this.mall_id}&compName=BYK&zhName=${zhName}&tFrom=bykSell`, // 需要转换为二维码的内容
          // text: "http://www.baidu.com",
          width: 600,
          height: 600,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        // this.QRCodeUrl = `https://openauth.alipay.com/oauth2/appToAppAuth.htm?app_id=2021002147672969&redirect_uri=http%3A%2F%2Fwww.91byk.com%2FbyPay%2FbyPayAliAuth.html&shPhone=${this.mallDisposeInfo.user_phone}&shMallId=${this.mall_id}&compName=BYK&zhName=${zhName}&tFrom=bykSell`;
      },
      // 生成 二维码
      // creatQrCodeMax() {
      //   // console.log(this.mallInfo);
      //   var qrcode = new this.QRCode(this.$refs.qrCodeUrlMax, {
      //     text: this.QRCodeUrl, // 需要转换为二维码的内容
      //     width: 600,
      //     height: 600,
      //     colorDark: "#000000",
      //     colorLight: "#ffffff",
      //     correctLevel: QRCode.CorrectLevel.H,
      //   });
      // },

      // 二维码放大
      fQRCodeEnlarge() {

        // document.getElementById("qrcode").innerHTML = "";
        // this.creatQrCode();
        this.QRCodeEnlargeDialog = !this.QRCodeEnlargeDialog;
      },
      // 放大后的二维码弹框开启事件
      maxQRCodeOpened() {
        // document.getElementById("qrcodeMax").innerHTML = "";
        // this.creatQrCodeMax();
        document.getElementById("qrcodeMax").innerHTML = "";
        this.creatQrCode();
      },

      // 设置付呗 H5 的支付路径
      async fSetFbWxH5Path() {
        let res = await this.fBykSetFbWxPayPath();

        if (res.result_code) {
          return this.$message(res.result_message);
        }
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message("设置付呗H5的支付路径成功");
      },
      //商户汇总
      async fShowMchTotal() {
        let res = await this.fGetMchTotal();
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.mchTotalInfo = res.data
        this.mchTotalPop = true
      },
      //测试
      fTest() {
        window.open("http://www.91byk.com/testSrvCon.html", '_blank');
      },
      //自助注册
      fSelfQrCreate() {
        setTimeout(() => {
          document.getElementById("selfQr").innerHTML = "";
          var qrcode = new this.QRCode(this.$refs.selfQrUrlMax, {
            text: `http://soft.sanmipos.com/smSell/index.html#/pages/shReg/shReg?o=${this.bykApi.global.fGetPlatform().partnerInfo.phone}&c=${this.bykApi.global.fGetPlatform().partnerInfo.data.comp_name}&reg=T`, // 需要转换为二维码的内容
            // text: "http://www.baidu.com",
            width: 300,
            height: 300,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });

        }, 200)

      },

      //摄像头
      async fGetJkList(e) {
        // this.mall_id = row.mall_id;
        // this.dzjqPop = true
        if (!isNaN(e)) {
          this.jkNowPage = e
        } else {
          // let jkQx = await this.bykApi.global.fGetSmMenuQx('电子价签')
          // if (!jkQx) {
          //   return this.$message('暂无电子价签权限');
          // }
          this.mall_id = e.mall_id;
          this.jkPop = true
        }
        let res = await this.fGetJkInfo({
          oper: 'LIST',
          mallId: this.jkRadio == '本店' ? this.mall_id : '0001', //选择门店
        })
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.jkData = res.data
        if (res.data && res.length > 0) {
          this.jkTR = res.data[0].TR
        }
      },
      //云打印机
      async fGetYdyjList(e) {
        // this.mall_id = row.mall_id;
        // this.dzjqPop = true
        if (!isNaN(e)) {
          this.ydyjNowPage = e
        } else {
          // let jkQx = await this.bykApi.global.fGetSmMenuQx('电子价签')
          // if (!jkQx) {
          //   return this.$message('暂无电子价签权限');
          // }
          this.mall_id = e.mall_id;
          this.mall_name = e.mall_name;
          this.ydyjPop = true
        }
        let res = await this.fGetCloudPrtInfo({
          oper: 'PRT_LIST',
          mallId: this.ydyjRadio == '本店' ? this.mall_id : '0001', //选择门店
          now_page: this.ydyjNowPage
        })
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.ydyjData = res.data
        if (res.data && res.length > 0) {
          this.ydyjTR = res.data[0].TR
        }
      },
      //电子价签  ========
      async fGetDzjqList(e) {
        // this.mall_id = row.mall_id;
        // this.dzjqPop = true
        if (!isNaN(e)) {
          this.dzjqNowPage = e
        } else {
          let dzjqQx = await this.bykApi.global.fGetSmMenuQx('电子价签')
          if (!dzjqQx) {
            return this.$message('暂无电子价签权限');
          }
          this.mall_id = e.mall_id;
          this.dzjqPop = true
        }
        let res = await this.fGetElabelInfo({
          oper: 'LIST',
          mallId: this.dzjqRadio == '本店' ? this.mall_id : '0001', //选择门店
        })
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.dzjqData = res.data
        if (res.data && res.length > 0) {
          this.dzjqTR = res.data[0].TR
        }
      },
      //关闭电子价签弹窗
      dzjqClose() {
        this.dzjqPop = false
        this.dzjqRadio = '本店'
      },
      jkClose() {
        this.jkPop = false
        this.jkRadio = '本店'
      },
      //电子价签分页
      // fDzjqCurrentChange(e) {
      //   this.dzjqNowPage = e
      //   let res = await this.fGetElabelInfo({
      //     oper: 'LIST',
      //     mallId: this.mall_id,
      //   })
      //   if (res.result != "sucess") {
      //     return this.$message(res.msg);
      //   }
      //   this.dzjqData = res.data
      // },
      //电子价签操作
      async fElabelOper(oper, labelId, labelName) {
        if (oper == 'DEL') {
          this.$confirm('是否确认删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirmButton',
          }).then(async () => {
            let res = await this.fElabelInfo({
              oper,
              mallId: this.mall_id,
              labelId: labelId,
              labelName: labelName,
            })
            this.fGetDzjqList({
              mall_id: this.mall_id
            })
          }).catch(() => {});
          return
        }
        let res = await this.fElabelInfo({
          oper,
          mallId: this.mall_id,
          labelId: this.dzjqInfo.dzjq_id,
          labelName: this.dzjqInfo.dzjq_name,
        })
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.dzjqInfo.dzjq_id = ''
        this.dzjqInfo.dzjq_name = ''
        this.fGetDzjqList({
          mall_id: this.mall_id
        })

      },
      //云打印机操作
      async fYdyjOper(oper, labelId, labelName, mch_token) {

        if (oper == 'SQ') {
          this.ydyjInfo.prt_id = labelId
          this.isSq = 'N'
          if (!this.bykApi.smCom.fSmIsEmpty(mch_token)) {
            this.isSq = 'Y'
          }
          console.log(this.isSq)
          this.ydyjSbsqPop = true
          return
        }
        if (oper == 'OPEN') {
          this.ydyjInfo = {
            prt_id: "",
            prt_maker: "gprinter",
            prt_name: "",
            prt_type: "bill",
            prt_port_type: "",
            prt_port: "",
            mch_token: "",
            def_yn: "Y",
            template_id: "",
            logo_url: "",
            bill_title: "",
            bill_end: "",
            bar_code: "",
            qr_code: "",
            paper_width: "32",
            feed_line: "0",
            cut_paper: "Y",
            sync_maker: "Y",
            state: "启用",
            user_memo: "",
          }
          this.ydyjEditPopTitle = '新增'
          this.ydyjEditPop = true
          return
        }
        if (oper == 'OPEN_EDIT') {
          let res = await this.fGetCloudPrtInfo({
            oper: 'PRT_ID',
            mallId: this.ydyjRadio == '本店' ? this.mall_id : '0001', //选择门店
            now_page: this.ydyjNowPage || 1,
            prt_id: labelId
          })
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.ydyjEditPop = true
          this.ydyjEditPopTitle = '修改'
          this.ydyjInfo = res.data
          return
        }
        if (oper == 'DEL') {
          this.$confirm('是否确认删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirmButton',
          }).then(async () => {
            let res = await this.fYdyjInfo({
              oper,
              mallId: this.mall_id,
            })
            this.$message(res.msg);
            this.ydyjEditPop = false
            this.fGetYdyjList({
              mall_id: this.mall_id,
              mall_name: this.mall_name
            })
          }).catch(() => {});
          return
        }
        let sOper = oper;
        if (sOper != 'UN_SET_TOKEN' && sOper != 'SET_TOKEN') {
          sOper = this.ydyjEditPopTitle == '修改' ? 'EDIT' : 'ADD'
        }
        let resProImg
        if (this.ydyjInfo.logo_url.substr(0, 4) == 'blob') {
          // this.uploadImgNum++
          resProImg = await this.fUpLoadImg({
            mchId: this.mallDisposeInfo.user_phone,
            type: 'logoImg',
            proId: this.mall_id,
            cloudType: 'logo',
            proName: this.mall_name,
            imgFile: this.ydyjInfo.file,
            imgMark: 'logo',
          })

        }


        let res = await this.fYdyjInfo({
          oper: sOper,
          mallId: this.mall_id,
          logo_url: resProImg || ''
        })
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.ydyjEditPop = false
        this.ydyjSbsqPop = false
        this.fGetYdyjList({
          mall_id: this.mall_id,
          mall_name: this.mall_name
        })

      },
      //授权萤石白名单
      // async fBmdAdd(deviceSerial) {
      //   let res = await axios.post('https://open.ys7.com/api/v3/mall/online/device/add', {
      //     accessToken: '',
      //     deviceSerial: '',
      //   });
      //   return res
      // },
      async fGetYscloudToken(obj) {
        let js = {};
        js["OPER"] = 'TOKEN';
        js['ORG_ID'] = 'ewjpky'
        js["APP_ID"] = 'smSell';
        console.log(js);
        let res = await this.bykApi.newSmApi.fPostToSmUnionQuery({
          sMethodName: 'GET_YSCLOUD_TOKEN',
          reqJson: js
        })
        console.log(res);
        return res;

      },
      //监控
      async fJklOper(oper, jkId, jkPsw) {
        // 白名单
        if (oper == 'SQ') {
          let tokenInfo = await this.fGetYscloudToken()
          if (tokenInfo.result != "sucess") {
            return this.$message(tokenInfo.msg);
          }
          // let ysBmdInfo = await this.axios.post('https://open.ys7.com/api/v3/mall/online/device/add', {
          //   accessToken: tokenInfo.token,
          //   deviceSerial: jkId,
          // });
          await this.axios({
            method: "post",
            // url: 'http://' + this.$store.state.smSellAdmin.fwqIp + ':5833' + '/upFile/',
            url: 'https://open.ys7.com/api/v3/mall/online/device/add',
            headers: {
              "Content-Type": "multipart/form-data",
              accessToken: tokenInfo.token,
              deviceSerial: jkId,
            },
          }).then((ysBmdInfo) => {
            console.log(ysBmdInfo, 'ysBmdInfo')
            this.$message(ysBmdInfo.data.meta.message);
          });

          return
        }
        if (oper == 'DEL') {
          this.$confirm('是否确认删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'confirmButton',
          }).then(async () => {
            let res = await this.fJkInfo({
              oper,
              mallId: this.mall_id,
              jkId: jkId,
              jkPsw: jkPsw,
            })
            this.fGetJkList({
              mall_id: this.mall_id
            })
          }).catch(() => {});
          return
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.jkInfo.jkId)) {
          return this.$message('请输入序列号');
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.jkInfo.jkPsw)) {
          return this.$message('请输入验证码');
        }
        let res = await this.fJkInfo({
          oper,
          mallId: this.mall_id,
          jkId: this.jkInfo.jkId,
          jkPsw: this.jkInfo.jkPsw,
          exTime: this.jkInfo.exTime,
        })
        this.$message(res.msg);
        if (res.result != "sucess") {
          return
        }
        this.jkInfo.jkId = ''
        this.jkInfo.jkPsw = ''
        this.jkInfo.exTime = new Date(new Date().getTime() + 360 * 24 * 60 * 60 * 1000)
        this.fGetJkList({
          mall_id: this.mall_id
        })

      },

      async fChgUserPhone() {

        this.$confirm('是否确认变更为：' + this.shInfo.partnerPhone, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fUserList()
          this.$message(res.msg);
        }).catch(() => {});
        return



      },
      //自动下载操作
      fAutoJsonOper(oper, item) {
        console.log(item)
        if (oper == 'ADD') {
          if (this.bykApi.smCom.fSmIsEmpty(item.soft_name)) {
            return this.$message('请输入软件名称');
          }
          if (this.bykApi.smCom.fSmIsEmpty(item.soft_ver)) {
            return this.$message('请输入软件版本');
          }
          if (this.bykApi.smCom.fSmIsEmpty(item.down_url)) {
            return this.$message('请输入软件下载链接');
          }
          this.autoJson.push(item)
          this.autoJsonInfo = {
            soft_name: '',
            soft_ver: '',
            down_url: '',
            enable_yn: 'N'
          }
        }
        if (oper == 'DEL') {
          this.autoJson.splice(item.rowIndex, 1)
        }
      },

      //更多弹窗
      async fShowMorePop(item) {
        console.log(this.autoJsonInfo)
        this.autoJson = []
        this.showMorePop = true
        this.autoSetMchId = item.user_phone
        this.$nextTick(async () => {
          let autoRes = await this.fAutoAz('GET_MCH_AUTO_SETUP')
          if (autoRes.result != "sucess") {
            return this.$message(autoRes.msg);
          }
          this.autoJson = JSON.parse(JSON.stringify(autoRes.auto_setup))
        })

      },
      //自动安装
      async fAutoAz(oper) {
        if (oper == 'GET_MCH_AUTO_SETUP') {
          let js = {
            OPER: 'AUTO_SETUP',
            MCH_ID: this.autoSetMchId
          }
          let res = await this.bykApi.newSmApi.fPostToSmSellMainQueryApi({
            sMethodName: 'GET_MCH_AUTO_SETUP',
            reqJson: js,
          });
          return res
        }
        if (oper == 'USER_LIST') {
          let js = {
            OPER: 'AUTO_SETUP',
            MCH_ID: this.autoSetMchId,
            AUTO_SETUP: this.autoJson
          }
          let res = await this.bykApi.newSmApi.fPostToSmSellMainAdminApi({
            sMethodName: 'USER_LIST',
            reqJson: js,
          });
          this.$message(res.msg);
          return res
        }
      },
      //保存短信签名
      async fSetSms() {
        let js = {};
        js["OPER"] = 'SMS_SIGN';
        js["SMS_SIGN"] = this.mallInfo.sms_sign
        js["CHG_USER_ID"] = '1001'
        js["MALL_ID"] = this.mallInfo.mallId
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('VIP_PARAM_OPTION', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        // this.$message(res.msg);
        // if (res.result == 'sucess') {
        //   this.innerModifyMall = false
        // }
        if (res.result == "sucess") {
          // this.innerModifyMall = false;
          // this.fInnerClose();
          this.init();
          let res = await this.fBykShMallInfo();
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.mallData = res.data;
          this.mallInfo.mdMoney = res.reg_info[0].sell_md_money

        }
        return this.$message(res.msg);
        // return res;
      },
      async fImgChg(file, type, index) {
        //图片状态是ready时是添加图片
        // uploadImgNum
        if (file.status == 'ready') {
          // return
          let js = {
            file: file,
            logo_url: URL.createObjectURL(file.raw)
          }
          Object.assign(this.ydyjInfo, js)

          return
        }
      },
      async sendEmail() {

        // // 手机号格式校验
        // let phone = this.shPhone.replace(/\s/g, ""); //去除空格
        // let regs = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        // let result = regs.test(phone)
        // if (!result) {
        //   return this.$message('请输入正确的手机号');
        //   // console.log(this.shPhoneMsg)
        // }

        const TIME_COUNT = 60; //  更改倒计时时间
        if (!this.timer) {
          this.sendTime = TIME_COUNT;
          // //发送短信函数
          // console.log(this.shPhone)
          let res = await this.SRV_SEND_SMS({
            oper: 'SEND_SMS_YZM'
          })
          console.log(res)
          if (res.result != 'sucess') {
            return this.$message(res.msg);
          }
          // this.zqYzm = res.data
          this.clearReqId = res.req_id
          // console.log(res.data)
          this.showTime = false;
          this.timer = setInterval(() => {
            if (this.sendTime > 0 && this.sendTime <= TIME_COUNT) {
              this.sendTime--;
            } else {
              this.showTime = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
            }
          }, 1000);
        }
      },

      // ---------------------- 请求函数 开始 ------------------------
      async fElabelInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["CHG_USER_ID"] = '1001';
        js["MALL_ID"] = obj.mallId;
        js["LABEL_ID"] = obj.labelId;
        js["LABEL_NAME"] = obj.labelName;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('ELABEL_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        return res;
      },
      async fJkInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["ORG_ID"] = 'ewjpky' // 机构编码
        js["MCH_ID"] = this.jkMchId // 商户编码
        js["MALL_ID"] = obj.mallId;
        js["CAMERA_TYPE"] = 'sell零售' // 摄像头类型
        js["CAMERA_ID"] = obj.jkId // 摄像头ID
        js["CHG_USER_NAME"] = this.bykApi.global.fGetPlatform().partnerInfo.data.user_name // 修改人
        js["CAMERA_NAME"] = obj.jkId + '摄像头' // 摄像头名称
        js["CAMERA_PSW"] = obj.jkPsw // 摄像头密码
        js["REMARK"] = '' // 备注
        js["EXP_TIME"] = obj.exTime // 备注
        console.log(js);
        let res = await this.bykApi.postApi.fPostToNewAdminApi('adminApi', 'CAMERA_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api')
        console.log(res);
        return res;
      },

      async fGetElabelInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["MALL_ID"] = obj.mallId;
        js["PAGE_SIZE"] = 20;
        js["NOW_PAGE"] = this.dzjqNowPage;
        js["SEARCH_STR"] = this.dzjqSearchStr;
        js["MH_YN"] = 'Y';
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellQueryApi('GET_ELABEL_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        return res;
      },
      async fGetJkInfo(obj) {
        let js = {};
        js["OPER"] = 'CAMERA_LIST';
        js["MALL_ID"] = obj.mallId;
        js["ZC_YN"] = 'Y';
        console.log(js);
        let res = await this.bykApi.postApi.fPostToQueryApi('queryApi', 'GET_CAMERA_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api')
        console.log(res);
        return res;

      },
      async fGetMchTotal() {
        let js = {};
        js["OPER"] = "SRV_MCH_COUNT";
        // js["SH_PHONE"] = row.user_phone;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },
      // 获取商户列表信息
      async fBykGetShInfo() {
        // let desc = "desc";
        // let field = "creat_time";
        let js = {};
        js["OPER"] = "MCH_LIST";
        js["PAGE_SIZE"] = this.pageSize;
        js["NOW_PAGE"] = this.nowPage;
        // if (this.searchSortVal == "注册时间升序") {
        //   desc = "asc";
        // } else if (this.searchSortVal == "最后登录降序") {
        //   field = "last_login_time";
        // } else if (this.searchSortVal == "最后登录升序") {
        //   desc = "asc";
        //   field = "last_login_time";
        // } else if (this.searchSortVal == "商品数降序") {
        //   field = "pro_count";
        // } else if (this.searchSortVal == "商品数升序") {
        //   desc = "asc";
        //   field = "pro_count";
        // } else if (this.searchSortVal == "门店数降序") {
        //   field = "mall_count";
        // } else if (this.searchSortVal == "门店数升序") {
        //   desc = "asc";
        //   field = "mall_count";
        // } else if (this.searchSortVal == "支付账户降序") {
        //   field = "online_zh_name";
        // } else if (this.searchSortVal == "支付账户升序") {
        //   desc = "asc";
        //   field = "online_zh_name";
        // }
        js["TIME_TYPE"] = this.timeRadio;
        if (this.timeRadio == 'REG') {
          js["START_TIME"] = this.startTime + ' 00:00:00';
          js["OVER_TIME"] = this.overTime + ' 23:59:59';
          // js["START_TIME"] = this.time[0];
          // js["OVER_TIME"] = this.time[1];
        }
        if (this.timeRadio == 'LOGIN') {
          js["START_TIME"] = this.lastTime;
          js["OVER_TIME"] = this.lastTime;
        }

        // js["ASC_DESC"] = desc;
        // js["ASC_DESC_FIELD"] = field;
        js["ASC_DESC"] = this.sortAscDesc;
        js["ASC_DESC_FIELD"] = this.sortType;
        js["AREA_TYPE"] = this.searchTypeVal == "商户" ? "sh" : "partner";
        js["SHEN"] = this.shen;
        js["SHI"] = this.shi;
        js["QU"] = this.qu;
        js["SEARCH_STR"] = this.merInputVal;
        js["MH_YN"] = this.checked ? "Y" : "N";
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },

      // 获取商户详情信息
      async fBykGetShId(row) {
        let js = {};
        js["OPER"] = "MCH_ID";
        js["SH_PHONE"] = row.user_phone;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },
      // 删除商户详情信息
      async fDelMchInfo(phone) {
        let js = {};
        js["OPER"] = "DEL_MCH_MAIN";
        js["USER_PHONE"] = phone;
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        console.log(res);
        return res;
      },

      // 新增商户信息
      async fBykSellShReg() {
        let js = {};
        let time1 = new Date(this.shInfo.shOrderGoodsExpice);
        let time2 = new Date(this.shInfo.shShopMallExpice);
        js["OPER"] = "ADD_MCH_MAIN";
        js["USER_PHONE"] = this.shInfo.shPhone; //商户手机号
        js["PARTNER_PHONE"] = this.shInfo.partnerPhone; //服务商手机号
        js["SOFT_BB"] = this.shInfo.shEdition; //版本号
        js["USER_TYPE"] = this.shInfo.shUserType; // 用户类型
        js["USER_NAME"] = this.shInfo.shLxName; //联系人
        js["SHEN"] = this.addr[0];
        js["SHI"] = this.addr[1];
        js["QU"] = this.addr[2];
        js["ADDRESS"] = this.shInfo.shMallDetailAddress;
        js["MALL_NAME"] = this.shInfo.shMallName; //门店名称
        js["BUS_TYPE"] = this.shInfo.shIndustry; //行业
        js["BUS_MEMO"] = this.shInfo.shMainMarketing; //主要经营
        js["BZ_MEMO"] = this.shInfo.shRemarks; //自助注册
        js["FY_MONEY"] = this.shInfo.shAllCost; //299

        js["MUST_PAY_COUNT"] = this.shInfo.mustPayCount //0
        js["MAIN_URL"] = this.shInfo.shHomeUrl; //''
        js["GG_TY_YN"] = this.shInfo.shAdChoose ? "Y" : "N"; //N
        js["WS_YN"] = this.shInfo.wsYn ? "Y" : "N"; //N
        js["GG_URL"] = this.shInfo.shAdUrl; //''
        js["SHOP_NAME"] = this.shInfo.shCustomModelName; //''
        js["SHOP_URL_TO_YN"] = this.shInfo.shCustomModelChoose ? "Y" : "N"; //''
        js["SHOP_URL"] = this.shInfo.shCustomModelUrl;
        js["PC_CAN_USE_NUM"] = this.shInfo.shCanUseComputed; //可用电脑数
        js["MCH_SRV_IP"] = this.shInfo.mchSrvIp; //
        js["ORG_AK"] = this.shInfo.org_ak;
        js["ORG_SK"] = this.shInfo.org_sk;
        js["DH_STOP_TIME"] =
          time1.getFullYear() +
          "-" +
          (time1.getMonth() - 0 + 1) +
          "-" +
          time1.getDate();
        js["SC_STOP_TIME"] =
          time2.getFullYear() +
          "-" +
          (time2.getMonth() - 0 + 1) +
          "-" +
          time2.getDate(); //+30
        console.log(isNaN("-01-16") && !isNaN(Date.parse("-01-16")))
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        console.log(res);
        return res;
      },

      // 修改商户信息
      async fBykSellShEdit() {
        // console.log(this.shInfo.shMallAddress);
        let js = {};
        let time1 = new Date(this.shInfo.shOrderGoodsExpice);
        let time2 = new Date(this.shInfo.shShopMallExpice);
        js["OPER"] = "EDIT_MCH_MAIN";
        // js["SH_PHONE"] = this.shInfo.shPhone;
        js["USER_PHONE"] = this.shInfo.shPhone;
        js["PARTNER_PHONE"] = this.shInfo.partnerPhone
        js["SOFT_BB"] = this.shInfo.shEdition;
        js["USER_TYPE"] = this.shInfo.shUserType;
        js["USER_NAME"] = this.shInfo.shLxName;
        js["SHEN"] = this.addr[0];
        js["SHI"] = this.addr[1];
        js["QU"] = this.addr[2];
        js["ADDRESS"] = this.shInfo.shMallDetailAddress;
        js["MALL_NAME"] = this.shInfo.shMallName;
        js["BUS_TYPE"] = this.shInfo.shIndustry;
        js["BUS_MEMO"] = this.shInfo.shMainMarketing;
        js["BZ_MEMO"] = this.shInfo.shRemarks;
        js["FY_MONEY"] = this.shInfo.shAllCost;
        js["MUST_PAY_COUNT"] = this.shInfo.mustPayCount
        js["MAIN_URL"] = this.shInfo.shHomeUrl;
        js["JM_MALL_CAN_USE_NUM"] = this.shInfo.jm_mall_can_use_num;
        js["GG_TY_YN"] = this.shInfo.shAdChoose ? "Y" : "N";
        js["WS_YN"] = this.shInfo.wsYn ? "Y" : "N";
        js["GG_URL"] = this.shInfo.shAdUrl;
        js["SHOP_NAME"] = this.shInfo.shCustomModelName;
        js["SHOP_URL_TO_YN"] = this.shInfo.shCustomModelChoose ? "Y" : "N";
        js["SHOP_URL"] = this.shInfo.shCustomModelUrl;
        js["PC_CAN_USE_NUM"] = this.shInfo.shCanUseComputed;
        js["ORG_AK"] = this.shInfo.org_ak;
        js["ORG_SK"] = this.shInfo.org_sk;
        js["DH_STOP_TIME"] =
          time1.getFullYear() +
          "-" +
          (time1.getMonth() - 0 + 1) +
          "-" +
          time1.getDate();
        js["SC_STOP_TIME"] =
          time2.getFullYear() +
          "-" +
          (time2.getMonth() - 0 + 1) +
          "-" +
          time2.getDate();
        console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        return res;
      },

      // 获取支付配置详情
      async fBykShPayInfo(row) {
        let js = {};
        js["OPER"] = 'MAIN_SRV ';
        js["SH_PHONE"] = this.mallDisposeInfo.user_phone;
        js["MALL_ID"] = row.mall_id;
        // console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MCH_ONLINE_PAY_INFO', js);
        // 15058125376
        return res;
      },

      // 支付配置
      async fBykSellBandPay() {
        let postJson = {};
        // postJson["METHOD_NAME"] = "BYK_SELL_BAND_PAY";
        // postJson["METHOD_NAME"] = "SMSELL_BAND_PAY";
        postJson["OPER"] = "MAIN_SRV";
        postJson["MCH_ID"] = this.mallDisposeInfo.user_phone;
        postJson["ZH_NAME"] = this.paymentInfo.payWay;
        postJson["MALL_ID"] = this.mall_id;
        postJson["ZH_USER_NAME"] = this.paymentInfo.bossName;
        postJson["ZH_USER_PHONE"] = this.paymentInfo.bossPhone;
        postJson["USER_MEMO"] = this.paymentInfo.payRemarks;
        postJson["CHG_PERSON"] = this.paymentInfo.fwsName;
        postJson["CHG_PERSON_PHONE"] = this.paymentInfo.fwsPhone;
        postJson["ZH_TYPE"] = this.zh_type



        postJson["PAY_ORG_ID"] = this.paymentInfo.payOrgId;
        postJson["PAY_ORG_MCH_ID"] = this.paymentInfo.payOrgMchId;
        postJson["WX_SUB_MCH_ID"] = this.paymentInfo.wxSubMchId;
        postJson["WX_APP_ID"] = this.paymentInfo.wxAppId;
        postJson["WX_MIN_APP_ID"] = this.paymentInfo.wxMinAppId;


        postJson["MR_MARK"] = "是";
        postJson["ALI_PAY_GF_YN"] = this.paymentInfo.payWayChoose ? "Y" : "N";
        postJson["APP_ID"] = this.paymentInfo.app_id;
        postJson["APP_SECRET"] = this.paymentInfo.app_secret;;
        postJson["APP_MALL_ID"] = this.paymentInfo.app_mall_id;




        postJson["PRV_KEY"] = this.paymentInfo.prv_key;
        postJson["PUB_KEY"] = this.paymentInfo.pub_key;

        if (this.paymentInfo.payWay == '星驿付') {
          postJson["APP_ID"] = '2007742458909540353';
          postJson["APP_SECRET"] =
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArjcBojBQv5WOWZetLEkaBQSFpeDrCl+f+XdkWArl0cb6KdpwJr1Z7l06zde+1N86m/cRvbziBYZDLmNnvCKqmAdahFDBZp8dmNmJ0ptbaQhoUM+/mXbaQJ8Oe2hbHtdxdOnn2ZhIdiI0uXrqTNpAIb6K/OKWUZfXHU6iAk4keTGo72MjiKvPRZv3dzaO4S4MPCN6ayrWUz18uuBCWjegWdyXqINsAbLpTVtNDAbNuRHIgZ6CKeeTGoG+UyODcU7/P0MFZutRQKpN/MB9rjJtQxAJ8ZDaZlsOX2Mvy2weQWOYqLoqWf3evVlK3YejgIN/PrYVaAiyJp/Y/8SVSqTgpQIDAQAB';
          postJson["PUB_KEY"] =
            'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArjcBojBQv5WOWZetLEkaBQSFpeDrCl+f+XdkWArl0cb6KdpwJr1Z7l06zde+1N86m/cRvbziBYZDLmNnvCKqmAdahFDBZp8dmNmJ0ptbaQhoUM+/mXbaQJ8Oe2hbHtdxdOnn2ZhIdiI0uXrqTNpAIb6K/OKWUZfXHU6iAk4keTGo72MjiKvPRZv3dzaO4S4MPCN6ayrWUz18uuBCWjegWdyXqINsAbLpTVtNDAbNuRHIgZ6CKeeTGoG+UyODcU7/P0MFZutRQKpN/MB9rjJtQxAJ8ZDaZlsOX2Mvy2weQWOYqLoqWf3evVlK3YejgIN/PrYVaAiyJp/Y/8SVSqTgpQIDAQAB';

        }
        console.log(postJson)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('SMSELL_BAND_PAY', postJson);

        return res;
      },

      // 获取商户门店列表信息
      async fBykShMallInfo() {
        let js = {};
        js["OPER"] = "MALL_LIST";
        js["SH_PHONE"] = this.mallDisposeInfo.user_phone;
        // console.log(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_MAIN_SRV_MCH_INFO', js);
        console.log(res);
        return res;
      },

      // 增加商户门店
      async fBykSellAddMall() {
        let postJson = {};
        postJson["OPER"] = 'MAIN_SRV'
        postJson["ORG_ID"] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        postJson["MCH_ID"] = this.mallDisposeInfo.user_phone;
        postJson["MALL_NAME"] = this.mallInfo.mallName;
        postJson["YEAR_MONEY"] = this.mallInfo.mallAnnualFee;
        postJson["MD_MONEY"] = this.mallInfo.mdMoney;
        postJson["SYNC_MALL_ID"] = this.mallInfo.sync_mall_id;
        postJson["STOP_TIME"] = this.mallInfo.expireTime;

        postJson["FORCE_PAY_YN"] = this.mallInfo.force_pay_yn;
        postJson["PAY_ORG_ID"] = this.mallInfo.pay_org_id;
        postJson["PAY_MCH_RATE"] = this.mallInfo.pay_mch_rate || '3.8';
        // console.log(postJson);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('ADD_MCH_MALL', postJson);
        console.log(res.data);
        return res;
      },

      // 修改商户门店信息
      async fBykSellEditMall(day) {
        let time = day || new Date(this.mallInfo.expireTime);
        let postJson = {};
        postJson["OPER"] = 'MAIN_SRV'
        postJson["ORG_ID"] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        postJson["MCH_ID"] = this.mallDisposeInfo.user_phone;
        postJson["MALL_ID"] = this.mallInfo.mallId;
        postJson["MALL_NAME"] = this.mallInfo.mallName;
        postJson["YEAR_MONEY"] = this.mallInfo.mallAnnualFee;
        postJson["MD_MONEY"] = this.mallInfo.mdMoney;
        postJson["ELABEL_MCH_ID"] = this.mallInfo.elabel_mch_id;
        postJson["ELABEL_MALL_ID"] = this.mallInfo.elabel_mall_id;


        postJson["STOP_TIME"] =
          time.getFullYear() +
          "-" +
          (time.getMonth() - 0 + 1) +
          "-" +
          time.getDate();
        postJson["ZB_XF_YN"] = this.mallInfo.zb_renew ? "Y" : "N";
        postJson["FORCE_PAY_YN"] = this.mallInfo.force_pay_yn;
        postJson["PAY_ORG_ID"] = this.mallInfo.pay_org_id;
        postJson["PAY_MCH_RATE"] = this.mallInfo.pay_mch_rate || '3.8';




        // console.log(postJson);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('EDIT_MCH_MALL', postJson);
        // console.log(res.data);
        return res;
      },

      // 清除所有数据
      async fBykSellClearData(oper, time1 = "", time2 = "") {
        let postJson = {};
        postJson["METHOD_NAME"] = "SM_SELL_CLEAR_DATA";
        postJson["SH_PHONE"] = this.mallDisposeInfo.user_phone;
        postJson["OPER"] = oper;
        postJson["START_TIME"] = time1;
        postJson["OVER_TIME"] = time2;
        postJson["PARTNER_PSW"] = this.partnerPwd;

        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('SMSELL_CLEAR_DATA', postJson);
        return res;
      },

      // 重置 1001 密码
      async fBykSellResetPwd() {
        let js = {};
        js["OPER"] = 'RESET_PSW_MAIN';
        js["USER_PHONE"] = this.mallDisposeInfo.user_phone;
        // let res = await this.bykApi.postApi.fPostToBykPlatFormoApi(js);
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('MAIN_SRV_MCH_MANGER', js);
        return res;
      },

      // 设置付呗 H5 的支付路径
      async fBykSetFbWxPayPath() {
        let js = {};
        js["USER_SERVER_IP"] = this.shServerIp;
        js["PHONE_NO"] = this.mallDisposeInfo.user_phone;
        js["METHOD_NAME"] = "SET_FB_WX_PAY_PATH";
        js["MALL_ID"] = this.mall_id;
        js["SUB_APP_ID"] = "wxab36abed3127b34a";
        js["JSAPI_PATH"] = "https://www.sanmipos.com/" //"http://www.91byk.com/";
        console.log(js)
        // let res = await this.bykApi.postApi.fPostToByPayApi(js);
        // let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('SET_FB_WX_PAY_PATH', js);
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('SET_FB_WX_PAY_PATH', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone)
        console.log(res)
        console.log(res)
        return res;
      },
      //升级
      async fExecSqlFile() {
        let js = {};
        js['OPER'] = 'smSellDbUpdate'
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('EXEC_SQL_FILE', js, this.shServerUrl, this
          .shServerIp, this.shInfo
          .shPhone)
        console.log(res)
        return res;
      },

      // 子服务器注册信息管理
      // 参数：OPER   USER_PHONE   SOFT_VER    FORCE_UPDATE_YN

      // OPER：
      // win大版本号：WIN_VER
      // 安装大版本号： ANDROID_VER
      // 强制更新值修改： FORCE_UPDATE
      async fSubSrvRegOper(oper) {
        this.$confirm('是否确认推送', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let verNo = oper == 'ANDROID_VER' ? this.mallInfo.androidVer : this.mallInfo.winVer
          if (oper == 'FORCE_UPDATE') {
            verNo = ''
          }
          let res = await this.fSubSrvRegInfo({
            oper: oper,
            ver: verNo,
            forceUpdateYn: this.mallInfo.forceUpdateYn,
          })
          return this.$message(res.msg);
        }).catch(() => {});
      },
      // 门店注册扩展信息
      // 参数：OPER  (客户化设置 SET_CUSTOM   门店调试设置 SET_DEBUG   获取  GET     推送 PUSH)
      async fMchRegEx(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        if (obj.oper == 'SET_DEBUG') {
          // if (this.bykApi.smCom.fSmIsEmpty(this.logSet.logMallId)) {
          //   return this.$message("开启调试门店不能为空");
          // }
          let listJson = {
            // "winPc": "00010001,00010002",
            // "androidPad": "00010001,00010002",
          }
          listJson[this.logSet.logVer] = this.logSet.logMallId
          console.log(listJson)
          js["MALL_LIST"] = JSON.stringify(listJson);

          js["MSG_TYPE"] = this.logSet.logVer
        }

        if (obj.oper == 'PUSH') {
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logMallId)) {
            return this.$message("查看调试日志门店不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logDate)) {
            return this.$message("查看调试日志日期不能为空");
          }
          js["MALL_ID"] = this.logGet.logMallId
          js["MSG_TYPE"] = 'winPcGetLog'
          js["LOG_DAY"] = this.logGet.logDate
        }
        if (obj.oper == 'SET_CUSTOM') {
          if (this.bykApi.smCom.fSmIsEmpty(this.custom.custom_name)) {
            return this.$message("客户名称不能为空");
          }

          js["CUSTOM_YN"] = this.custom.custom_yn || 'N'
          js["CUSTOM_NAME"] = this.custom.custom_name
          js["CUSTOM_URL"] = this.custom.custom_url
          js["CUSTOM_EX"] = this.custom.custom_ex
        }
        if (obj.oper == 'DOWN_LOAD') {
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logMallId)) {
            return this.$message("下载调试日志门店不能为空");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.logGet.logDate)) {
            return this.$message("下载调试日志日期不能为空");
          }
          this.downLoadUrl =
            `https://u.91byk.com/p${this.mallDisposeInfo.user_phone}/Log/${this.mallDisposeInfo.user_phone}_${this.logGet.logMallId}01_${this.logGet.logDate}.zip`
          // window.open(this.downLoadUrl)
          window.location.href = this.downLoadUrl
          //  http://u.91byk.com/p13800000005/Log/13800000005_0001000101_20231018.zip
          return
        }
        //   'http://u.91byk.com/p' + this.mallDisposeInfo.user_phone + '/Log/'+this.mallDisposeInfo.user_phone+'_0001000101_20231018.zip'
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('MCH_REG_EX', js, this.shServerUrl, this.shServerIp,
          this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        if (obj.oper == 'GET' && res.result == 'sucess') {
          return res;
        }
        this.$message(res.msg);
        return res;
      },

      async fSubSrvRegInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper;
        js["USER_PHONE"] = this.mallDisposeInfo.user_phone
        js["SOFT_VER"] = obj.ver
        js["FORCE_UPDATE_YN"] = obj.forceUpdateYn
        console.log(this.mallDisposeInfo.user_phone);
        console.log(this.shInfo.shPhone);
        let res = await this.bykApi.postApi.fPostToSmSellAdminApi('SUB_SRV_REG_INFO', js, this.shServerUrl, this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api');
        console.log(res);
        return res;
      },
      async fUserList(oper) {
        let js = {};
        js["OPER"] = 'CHG_PARTNER_PHONE'; // 必填 MALL_LIST MALL_ID
        js['MCH_ID'] = this.shInfo.shPhone;
        js['PARTNER_PHONE'] = this.shInfo.partnerPhone
        let res = await this.bykApi.postApi.fPostToAdminApi("USER_LIST", js);
        return res;
      },

      async fYdyjInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper // 机构编码
        js["MALL_ID"] = obj.mallId // 商户编码
        js["CHG_USER_ID"] = '1001';
        js["PRT_ID"] = this.ydyjInfo.prt_id // 打印机编码
        js["PRT_MAKER"] = this.ydyjInfo.prt_maker //打印机制造商：Gprinter佳博
        js["PRT_NAME"] = this.ydyjInfo.prt_name // 打印机名称
        js["PRT_TYPE"] = this.ydyjInfo.prt_type // 打印机类型：bill 小票、label 标签
        js["PRT_PORT_TYPE"] = this.ydyjInfo.prt_port_type // 打印机端口号类型
        js["PRT_PORT"] = this.ydyjInfo.prt_port // 打印机端口号
        js["MCH_TOKEN"] = this.ydyjInfo.mch_token // 商户token
        js["DEF_YN"] = this.ydyjInfo.def_yn // 是否默认
        js["TEMPLATE_ID"] = this.ydyjInfo.template_id // 模板id
        js["LOGO_URL"] = obj.logo_url // logo图片地址
        js["BILL_TITLE"] = this.ydyjInfo.bill_title // 票头
        js["BILL_END"] = this.ydyjInfo.bill_end // 票尾
        js["BAR_CODE"] = this.ydyjInfo.bar_code // 一维码
        js["QR_CODE"] = this.ydyjInfo.qr_code // 二维码
        js["PAPER_WIDTH"] = this.ydyjInfo.paper_width // 纸张宽度
        js["FEED_LINE"] = this.ydyjInfo.feed_line || 0 // 走纸
        js["CUT_PAPER"] = this.ydyjInfo.cut_paper // 切纸
        js["SYNC_MAKER"] = this.ydyjInfo.sync_maker || 'Y' // 授权模式
        js["STATE"] = this.ydyjInfo.state // 状态：启用、停用
        js["USER_MEMO"] = this.ydyjInfo.user_memo // 备注
        console.log(js);
        let res = await this.bykApi.postApi.fPostToNewAdminApi('adminApi', 'CLOUD_PRT_INFO', js, this.shServerUrl,
          this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api')
        console.log(res);
        return res;
      },

      async SRV_SEND_SMS(obj) {
        let js = {};
        js['OPER'] = obj.oper // 操作 发送短信验证码：SEND_SMS_YZM   验证短信验证码： CHK_SMS_YZM
        js['MCH_ID'] = this.mallDisposeInfo.user_phone // 商户号
        js['SMS_TYPE_ID'] = 'clear_data' // 业务类别id：清除数据 clear_data
        if (obj.oper == 'SEND_SMS_YZM') {
          js['CHG_PERSON'] = this.bykApi.global.fGetPlatform().partnerInfo.data.user_name // 修改人
          js['SMS_TYPE'] = '清除数据' // 业务类别名称
        }
        if (obj.oper == 'CHK_SMS_YZM') {
          js['SEND_PHONE'] = this.bykApi.global.fGetPlatform().partnerInfo.phone // 手机号
          js['SMS_KEY_TXT'] = this.clearYzm // 验证码
          js['REQ_ID'] = this.clearReqId // 发送批次
        }
        let res = await this.bykApi.newSmApi.fPostToSmSellMainAdminApi({
          sMethodName: 'SRV_SEND_SMS',
          reqJson: js,
        });
        return res
      },


      // 获取云打印机信息
      // 接口名：GET_CLOUD_PRT_INFO
      // 参数：
      //     OPER // 操作：LIST 列表    PRT_ID 详情
      //     MALL_ID // 门店编码
      //     PRT_ID // 打印机编码
      //     ZC_YN // 状态
      //     SEARCH_STR // 搜索内容
      //     MH_YN // 是否模糊搜索
      //     PAGE_SIZE // 必传 每页记录数 默认 50
      //     NOW_PAGE // 必传 当前页码
      //     ORDER_BY // 排序
      async fGetCloudPrtInfo(obj) {
        let js = {};
        js["OPER"] = obj.oper // 机构编码
        js["MALL_ID"] = obj.mallId // 商户编码
        js["PRT_ID"] = obj.prt_id;
        js["ZC_YN"] = ''
        js["SEARCH_STR"] = obj.search_str
        js["MH_YN"] = 'Y'
        js["PAGE_SIZE"] = '50'
        js["NOW_PAGE"] = obj.now_page
        js["ORDER_BY"] = ''
        console.log(js);
        let res = await this.bykApi.postApi.fPostToQueryApi('Query', 'GET_CLOUD_PRT_INFO', js, this.shServerUrl,
          this
          .shServerIp, this
          .mallDisposeInfo.user_phone, 'smStream719ee78131675d5ed4cacbe41e1c8191Api')
        console.log(res);
        return res;
      },


      // ---------------------- 请求函数 结束 ------------------------
    },
  };
</script>

<style lang='less' scoped>
  .merchant {
    .header {

      // height: 50px;
      // display: flex;
      // margin-bottom: 8px;
      // margin-right: 20px;
      // justify-content: space-between;
      // align-items: center;
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }

      // /deep/ .buy-software .el-button--warning.is-plain {
      //   border-color: #409eff;
      //   color: #000;
      // }
      // /deep/ .buy-software .el-button--warning.is-plain:hover {
      //   background-color: #409eff;
      //   color: #fff;
      // }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding-right: 40px;
      // height: 600px;
      // overflow-y: scroll;
    }

    .dialog-title {
      line-height: 17px;
      font-size: 14px;
      padding-left: 8px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e6e6e6;
      position: relative;

      &::after {
        content: "";
        display: flex;
        width: 3px;
        height: 14px;
        position: absolute;
        left: 0;
        top: 2px;
        border-left: 3px solid #2c6ff2;
      }
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        color: #606266;
      }
    }

    .centent {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding-bottom: 30px;

      .buy {
        display: flex;
        width: 200px;
        flex-direction: column;
        border: 2px solid #f0f0f0;
        border-radius: 5px;
        overflow: hidden;
        margin-top: 50px;

        .buy-title {
          font-size: 16px;
          font-weight: bold;
          margin: 20px 20px 8px;
        }

        .price {
          font-size: 25px;
          color: #f76062;
          margin: 20px 20px;
        }

        div {
          margin: 5px 20px;
        }
      }

      .buy-active {
        color: #2c6ff2;
        background-color: #f4f8ff;
        border: 2px solid #2c6ff2;

        /deep/ .el-button--default {
          background-color: #2c6ff2;
          color: #fff;
        }
      }
    }

    .partnerPhone {
      /deep/ .el-input__inner {
        padding: 0 5px;
      }

      /deep/ .el-input-group__append {
        padding: 0 5px;
        background-color: #fff;
        color: rgb(144, 147, 153);
      }
    }

    // 自助注册二维码样式
    .left-line {
      display: flex;
      position: relative;

      &::before {
        content: "";
        display: flex;
        width: 4px;
        height: 20px;
        background-color: #2c6ff2;
        top: 0;
        left: 0;
        margin-right: 10px;
      }
    }

    .must {
      position: relative;

      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    // /deep/ .el-button--default {
    //   border-radius: 0;
    //   border: 0;
    //   background-color: #f0f0f0;
    //   color: #808080;
    //   height: 45px;
    // }
    .zh-type {
      color: #679aff;
      border-bottom: 1px solid #679aff;
    }

    /deep/ .el-step__head.is-finish,
    /deep/.el-step__title.is-finish {
      color: unset;
      border-color: unset;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/merchant.vue